import React,{useContext,useEffect, useState, useRef,useReducer, useMemo, useCallback} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest ,deleteRequest, putRequest} from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon,EditRowIcon,DeleteIcon, EditIcon, PaperClipIcon, ActivateIcon, DeactivateIcon} from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import AuthContext from '../../components/AuthContext';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import { DateTime } from "luxon";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css'
import UtilContext from '../../components/UtilContext';
import { MaintenanceMaskDialogCheckbox } from '../../components/maintenance/MaintenanceMaskDialogCheckbox';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import ReactDOMServer from 'react-dom/server';
import { TabView, TabPanel } from 'primereact/tabview';
import { Avatar } from 'primereact/avatar';
import { Dropdown } from 'primereact/dropdown';
import { createAsyncNavigateHandlers } from '../../utils/asyncArrayNavigate';
import { navigationContextToQueryParams } from '../../utils/maintenanceNavigationContext';
import { useMaintenanceTypes } from '../../utils/useMaintenanceTypes';
import { useMachineCards } from '../../utils/useMachineCards';
import { getPusherChannel } from '../../utils/pusherChannel';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import {
  buildCanonicalPrintFooterHtml,
  buildCanonicalPrintHeaderHtml,
} from '../../utils/printChrome';
import {
    applyCompanyListColumnLayout,
    cleanSorters,
    restoreCompanyListUserMaskToTable,
    safeParse,
} from '../../utils/tabulatorProgressiveLoading';
import { getEffectiveMask } from '../../utils/effectiveMask';
import {
    buildMaintenanceMaskAkcieSubItems,
    createConfirmSaveStandardMask,
    createConfirmApplyStandardLayoutToUserMask,
    clearHeaderFilterForField,
    normalizeColumnVisibilityForSave,
    createMaskSetFieldHandler,
    createMaskSelectAllHandler,
    createMaskDeselectAllHandler,
    hasApplicableStandardMaskRow,
    mergeColumnVisibilityFromSaved,
    ensureMaskDialogState,
    MAINTENANCE_MASK_DIALOG_SKIP_FIELDS,
} from '../../utils/maintenanceTabulatorMaskActions';
import { getTabulatorPersistLayoutEvents } from '../../utils/tabulatorPersistLayout';
import { buildAuditTabulatorColumns, mergeColumnVisibilityWithAuditDefaults } from '../../utils/tabulatorAuditColumns';
import { tabulatorColumnMinWidthFromTitle, TABULATOR_LIST_ID_MIN_WIDTH } from '../../utils/tabulatorColumnMinWidth';
import { primeMultiSelectHeaderFilter } from '../../utils/primeMultiSelectHeaderFilter';
import { LocaleContext } from '../../components/LocaleContext';

const DEFAULT_MAINTENANCE_CARD_DETAIL_COLUMN_VISIBILITY = Object.freeze({
    id: true,
    'maintenance_type.name': true,
    initial_date: true,
    deactivation_date: true,
    description: true,
    machine_part: true,
    required_attachment: true,
    scheduled_files: true,
    'company.name': true,
    custom_lecturer_name: true,
    custom_contact_name: true,
    'maintenance_type.type': true,
    'maintenance_type.norm': true,
    'maintenance_type.interval_months': true,
    'maintenance_type.responsible.name': true,
    'maintenance_type.description': true,
    created_at: true,
    updated_at: true,
});

const MAINTENANCE_CARD_DETAIL_DATA_FIELD_ORDER = Object.freeze([
    'id',
    'maintenance_type.name',
    'initial_date',
    'deactivation_date',
    'description',
    'machine_part',
    'required_attachment',
    'scheduled_files',
    'company.name',
    'custom_lecturer_name',
    'custom_contact_name',
    'maintenance_type.type',
    'maintenance_type.norm',
    'maintenance_type.interval_months',
    'maintenance_type.responsible.name',
    'maintenance_type.description',
    'created_at',
    'updated_at',
]);

const DEFAULT_MAINTENANCE_CARD_DETAIL_CHECKLIST_COLUMN_VISIBILITY = Object.freeze({
    id: true,
    name: true,
    custom_department: true,
    users: true,
    sending_data: true,
    cusom_notif_before: true,
    manager_name: true,
    manager_due_days: true,
    description: true,
    is_active: true,
    created_at: true,
    updated_at: true,
});

const MAINTENANCE_CARD_DETAIL_CHECKLIST_DATA_FIELD_ORDER = Object.freeze([
    'id', 'name', 'custom_department', 'users', 'sending_data', 'cusom_notif_before',
    'manager_name', 'manager_due_days', 'description', 'is_active',
    'created_at', 'updated_at',
]);

const DEFAULT_MAINTENANCE_CARD_DETAIL_TECHNICIANS_COLUMN_VISIBILITY = Object.freeze({
    id: true,
    company_name: true,
    name: true,
    tel_number: true,
    email: true,
    description: true,
    technician_type: true,
    created_at: true,
    updated_at: true,
});

const MAINTENANCE_CARD_DETAIL_TECHNICIANS_DATA_FIELD_ORDER = Object.freeze([
    'id', 'company_name', 'name', 'tel_number', 'email', 'description', 'technician_type',
    'created_at', 'updated_at',
]);

function mergeMaintColumnVisibilityFromSaved(saved) {
    return mergeColumnVisibilityWithAuditDefaults(DEFAULT_MAINTENANCE_CARD_DETAIL_COLUMN_VISIBILITY, saved);
}

function applyMaintDataColumnVisibility(table, visibility) {
    if (!table) return;
    for (const field of Object.keys(DEFAULT_MAINTENANCE_CARD_DETAIL_COLUMN_VISIBILITY)) {
        if (visibility[field] === false) {
            clearHeaderFilterForField(table, field);
            table.hideColumn?.(field);
        } else {
            table.showColumn?.(field);
        }
    }
    setTimeout(() => table.redraw?.(true), 0);
}

function mergeChecklistColumnVisibilityFromSaved(saved) {
    return mergeColumnVisibilityWithAuditDefaults(DEFAULT_MAINTENANCE_CARD_DETAIL_CHECKLIST_COLUMN_VISIBILITY, saved);
}

function applyChecklistDataColumnVisibility(table, visibility) {
    if (!table) return;
    for (const field of Object.keys(DEFAULT_MAINTENANCE_CARD_DETAIL_CHECKLIST_COLUMN_VISIBILITY)) {
        if (visibility[field] === false) {
            clearHeaderFilterForField(table, field);
            table.hideColumn?.(field);
        } else {
            table.showColumn?.(field);
        }
    }
    setTimeout(() => table.redraw?.(true), 0);
}

function mergeTechniciansColumnVisibilityFromSaved(saved) {
    return mergeColumnVisibilityWithAuditDefaults(DEFAULT_MAINTENANCE_CARD_DETAIL_TECHNICIANS_COLUMN_VISIBILITY, saved);
}

function applyTechniciansDataColumnVisibility(table, visibility) {
    if (!table) return;
    for (const field of Object.keys(DEFAULT_MAINTENANCE_CARD_DETAIL_TECHNICIANS_COLUMN_VISIBILITY)) {
        if (visibility[field] === false) {
            clearHeaderFilterForField(table, field);
            table.hideColumn?.(field);
        } else {
            table.showColumn?.(field);
        }
    }
    setTimeout(() => table.redraw?.(true), 0);
}

function resolveTabulatorInstance(wrapperRef) {
    return wrapperRef?.current?.table ?? wrapperRef?.current ?? null;
}

/**
 * mntn017 embedded local tabuľky — Enter-only text filter (apply aj clear po Enter).
 * Bez input listenera; bez setHeaderFilterValue / refreshFilter.
 */
function embeddedEnterOnlyHeaderFilter(cell, onRendered, success, cancel, editorParams) {
    const mount = document.createElement('div');
    mount.style.cssText = 'padding:0;width:100%;max-width:100%;min-width:0;box-sizing:border-box;';
    const column = cell.getColumn?.();
    const initial = column?.getHeaderFilterValue?.() ?? cell.getValue?.() ?? '';
    const input = document.createElement('input');
    input.type = 'text';
    input.value = initial === undefined || initial === null ? '' : String(initial);
    input.placeholder = editorParams?.placeholder ?? '';
    input.style.cssText = 'width:100%;padding:4px;box-sizing:border-box;';
    input.setAttribute('data-header-filter-input', '1');

    const applyFilter = () => {
        const v = input.value == null ? '' : String(input.value).trim();
        success(v);
    };

    input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            setTimeout(applyFilter, 0);
        }
    });

    mount.appendChild(input);
    onRendered(() => {});

    return mount;
}

export default function MaintenanceCardDetail({machine, type, navigationContext}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { t } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,setStandardMaskFilter,getUserColor,getUserInitials,openFilePreview,getDateFormat, openChosenNotificationPreferences} = useContext(UtilContext);
    const {user} = useContext(AuthContext);
    const [tabIndex, setTabIndex] = useState(0);
    const ref = useRef(null);
    const refMaint = useRef(null);
    const refMaintTabulator = useRef(null);
    const refChecklist = useRef(null);
    const refChecklistTabulator = useRef(null);
    const maintTabActive = tabIndex === 0;
    const { maintenanceTypes: allMaintenanceTypes, loading: loadingTypes } = useMaintenanceTypes({ enabled: maintTabActive });
    const { machineCards, loading: loadingMachineCards, refetch: refetchMachineCards } = useMachineCards({ enabled: maintTabActive });

    const [closeTab,setCloseTab] = useState(false);
    const submitRef = useRef(null);
    const overlayRef = useRef(null);

    const [machineType,setMachineType] = useState([]);
    const [maintenanceTypes,setMaintenanceTypes] = useState([]);

    useEffect(() => {
        setMaintenanceTypes(allMaintenanceTypes);
    }, [allMaintenanceTypes]);

    // Načítavanie v tabuľke cez natívny Tabulator (ako trng015) – alert/clearAlert
    useEffect(() => {
        if (tabIndex !== 0) return;
        const table = refMaintTabulator.current;
        if (!table) return;
        if (loadingMachineCards || loadingTypes) {
            if (table.initialized) table.alert?.(t('Common.LoadingData'));
        } else {
            table.clearAlert?.();
        }
    }, [tabIndex, loadingMachineCards, loadingTypes]);

    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';

    const [columnsVisible, setColumnsVisible] = useState(() => ({ ...DEFAULT_MAINTENANCE_CARD_DETAIL_COLUMN_VISIBILITY }));
    const [maskVisible, setMaskVisible] = useState(false);
    /** Záložka pri otvorení dialógu masky (tri rôzne tabuľky / user_mask page kľúče). */
    const [maskDialogTabIndex, setMaskDialogTabIndex] = useState(0);
const [formMachine,setFormMachine] = useState(machine);
    const currentMachineIdRef = useRef(machine?.id ?? null);
    const prevMachineIdRef = useRef(machine?.id);
    const [formType, setFormType] = useState(type);

    useEffect(() => {
        currentMachineIdRef.current = formMachine?.id ?? null;
    }, [formMachine?.id]);

    const [companyContactsList, setCompanyContactsList] = useState([]);
    const [companyContacts, setCompanyContacts] = useState([]);
    const [machines, setMachines] = useState(state.machines);
    const effectiveMaintenanceCompanyContacts = (state.maintenance_company_contacts || []).length ? (state.maintenance_company_contacts || []) : companyContactsList;
    const effectiveMaintenanceContactsRef = useRef(effectiveMaintenanceCompanyContacts);
    effectiveMaintenanceContactsRef.current = effectiveMaintenanceCompanyContacts;

    const techniciansTableData = useMemo(() => {
        const list = effectiveMaintenanceCompanyContacts;
        const companies = state.maintenance_companies || [];
        const employees = state.employees || [];
        return list.map((c) => {
            const emp = c.employee_id ? employees.find((e) => Number(e.id) === Number(c.employee_id)) : null;
            return {
                ...c,
                company_name: companies.find((co) => Number(co.id) === Number(c.company_id))?.name ?? '',
                technician_type: c.employee_id ? t('Common.InternalEmployee') : t('Common.ServiceCompanyEmployee'),
                employee: c.employee || emp,
                tel_number: c.tel_number ?? emp?.tel_number ?? '',
                email: c.email ?? emp?.email ?? '',
                name: c.name ?? emp?.name ?? '',
                description: c.description ?? '',
            };
        });
    }, [effectiveMaintenanceCompanyContacts, state.maintenance_companies, state.employees]);

    const [favoriteContactsFromApi, setFavoriteContactsFromApi] = useState([]);
    const favoriteContactsFromApiRef = useRef(favoriteContactsFromApi);
    favoriteContactsFromApiRef.current = favoriteContactsFromApi;
    const [visibleFavoritePicker, setVisibleFavoritePicker] = useState(false);
    const [favoritePickerIds, setFavoritePickerIds] = useState([]);
    const [favoriteWizardCompanyId, setFavoriteWizardCompanyId] = useState('');
    const [favoriteWizardLecturerId, setFavoriteWizardLecturerId] = useState('');
    const [favoriteWizardContactId, setFavoriteWizardContactId] = useState('');
    /** null = dialóg na pridanie; číslo = úprava — pri uložení sa tento kontakt odoberie a nahradí výberom vo wizardovi. */
    const [favoriteEditReplaceId, setFavoriteEditReplaceId] = useState(null);

    const favoriteTechniciansTableData = useMemo(() => {
        const companies = state.maintenance_companies || [];
        const employees = state.employees || [];
        return (favoriteContactsFromApi || []).map((c) => {
            const enriched = techniciansTableData.find((t) => String(t.id) === String(c.id));
            const emp = c.employee_id ? employees.find((e) => Number(e.id) === Number(c.employee_id)) : null;
            return {
                ...c,
                company_name: enriched?.company_name ?? companies.find((co) => Number(co.id) === Number(c.company_id))?.name ?? c.company?.name ?? '',
                technician_type: c.employee_id ? t('Common.InternalEmployee') : t('Common.ServiceCompanyEmployee'),
                employee: c.employee || enriched?.employee || emp,
                tel_number: c.tel_number ?? enriched?.tel_number ?? emp?.tel_number ?? '',
                email: c.email ?? enriched?.email ?? emp?.email ?? '',
                name: c.name ?? enriched?.name ?? emp?.name ?? '',
                description: c.description ?? enriched?.description ?? '',
            };
        });
    }, [favoriteContactsFromApi, techniciansTableData, state.maintenance_companies, state.employees]);

    const favoriteWizardFilteredContacts = useMemo(() => {
        if (!favoriteWizardCompanyId) return [];
        const base = effectiveMaintenanceCompanyContacts.filter((c) => String(c.company_id) === String(favoriteWizardCompanyId));
        const lec = favoriteWizardLecturerId === '' || favoriteWizardLecturerId == null ? null : Number(favoriteWizardLecturerId);
        if (lec === null || Number.isNaN(lec)) return [];
        return lec === 1 ? base.filter((c) => c.employee_id != null) : base.filter((c) => c.employee_id == null);
    }, [favoriteWizardCompanyId, favoriteWizardLecturerId, effectiveMaintenanceCompanyContacts]);

    const favoritePendingNewFromWizard = useMemo(() => {
        if (!favoriteWizardContactId) return false;
        const nid = Number(favoriteWizardContactId);
        if (Number.isNaN(nid)) return false;
        return !favoritePickerIds.some((x) => Number(x) === nid);
    }, [favoriteWizardContactId, favoritePickerIds]);

    const isFavoriteEditReplaceMode = favoriteEditReplaceId != null && favoriteEditReplaceId !== '';
    /** Pridať: vybraný kontakt už je medzi obľúbenými pre stroj — uložiť nejde. */
    const favoriteAddDuplicateSelection = useMemo(() => {
        if (isFavoriteEditReplaceMode) return false;
        if (!favoriteWizardContactId) return false;
        const nid = Number(favoriteWizardContactId);
        if (Number.isNaN(nid)) return false;
        return favoritePickerIds.some((x) => Number(x) === nid);
    }, [isFavoriteEditReplaceMode, favoriteWizardContactId, favoritePickerIds]);
    /** Pridať: nový technik ešte nie v zozname. Úprava: iný kontakt ako ten, ktorý sa nahrádza. */
    const canSaveFavoriteDialog =
        (!isFavoriteEditReplaceMode && favoritePendingNewFromWizard) ||
        (isFavoriteEditReplaceMode &&
            favoriteWizardContactId &&
            Number(favoriteWizardContactId) !== Number(favoriteEditReplaceId));

    const loadFavoriteMaintenanceContacts = useCallback(() => {
        if (!formMachine?.id) return;
        getRequest(`/api/machines/${formMachine.id}/favorite-maintenance-contacts`)
            .then((r) => {
                const list = r?.data ?? [];
                setFavoriteContactsFromApi(Array.isArray(list) ? list : []);
            })
            .catch(() => {});
    }, [formMachine?.id]);

    useEffect(() => {
        if (tabIndex !== 2 || !formMachine?.id) return;
        loadFavoriteMaintenanceContacts();
    }, [tabIndex, formMachine?.id, loadFavoriteMaintenanceContacts]);

    useEffect(() => {
        if ((state.maintenance_company_contacts || []).length > 0) return;
        getRequest("/api/company_contacts?minimal=1&module=maintenance")
            .then((r) => { const list = r?.data ?? r ?? []; setCompanyContactsList(Array.isArray(list) ? list : []); })
            .catch(() => {});
    }, [state.maintenance_company_contacts?.length]);

    //TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add maintenance"))?false:true);
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit maintenance"))?false:true);
    const [visibleCard,setVisibleCard] = useState(false);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [copyIcon,setCopyIcon] = useState(true);
    const [activateIcon,setActivateIcon] = useState(true);
    const [deactivateIcon,setDeactivateIcon] = useState(true);
    const [visibleDeactivate, setVisibleDeactivate] = useState(false);

    const [selectedCard,setSelectedCard] = useState(null);

    const [showMachineCardAdd, setShowMachineCardAdd] = useState(false);
    const [images,setImages] = useState('');

    const [fileList, setFileList] = useState([]);
    const fileListRef = useRef(null);

    const [updatefileList, setUpdateFileList] = useState([]);
    const updateFileListRef = useRef(null);

    const PAGE_MAINT = "MaintenanceCardDetail";
    const PAGE_CHECKLIST = "MaintenanceCardDetail_ChecklistTemplates";
    const PAGE_TECHNICIANS = "MaintenanceCardDetail_ServiceTechnicians";
    /** Všetky 3 embedded tabuľky: LOCAL Tabulator (`data` prop), bez ajaxURL/progressiveLoad/filterMode remote. */

    const [columnsVisibleChecklist, setColumnsVisibleChecklist] = useState(() => ({ ...DEFAULT_MAINTENANCE_CARD_DETAIL_CHECKLIST_COLUMN_VISIBILITY }));

    const refTechnicians = useRef(null);
    const refTechniciansTabulator = useRef(null);
    const [columnsVisibleTechnicians, setColumnsVisibleTechnicians] = useState(() => ({ ...DEFAULT_MAINTENANCE_CARD_DETAIL_TECHNICIANS_COLUMN_VISIBILITY }));
    const isRestoringMaintRef = useRef(false);
    const isRestoringChecklistRef = useRef(false);
    const isRestoringTechniciansRef = useRef(false);
    const canSetStandardMask = user?.permissions?.includes('set standard mask');
    const [deleteTechnicianIcon, setDeleteTechnicianIcon] = useState(true);
    const [editTechnicianIcon, setEditTechnicianIcon] = useState(true);

    const active = React.useMemo(() => {
        if (tabIndex === 0) {
            return {
                page: PAGE_MAINT,
                ref: refMaint,
                columnsVisible,
                setColumnsVisible,
                defaultVisibility: DEFAULT_MAINTENANCE_CARD_DETAIL_COLUMN_VISIBILITY,
                mergeVisibilityFromSaved: mergeMaintColumnVisibilityFromSaved,
                applyVisibilityToTable: applyMaintDataColumnVisibility,
                isRestoringRef: isRestoringMaintRef,
            };
        }
        if (tabIndex === 2) {
            return {
                page: PAGE_TECHNICIANS,
                ref: refTechnicians,
                columnsVisible: columnsVisibleTechnicians,
                setColumnsVisible: setColumnsVisibleTechnicians,
                defaultVisibility: DEFAULT_MAINTENANCE_CARD_DETAIL_TECHNICIANS_COLUMN_VISIBILITY,
                mergeVisibilityFromSaved: mergeTechniciansColumnVisibilityFromSaved,
                applyVisibilityToTable: applyTechniciansDataColumnVisibility,
                isRestoringRef: isRestoringTechniciansRef,
            };
        }
        return {
            page: PAGE_CHECKLIST,
            ref: refChecklist,
            columnsVisible: columnsVisibleChecklist,
            setColumnsVisible: setColumnsVisibleChecklist,
            defaultVisibility: DEFAULT_MAINTENANCE_CARD_DETAIL_CHECKLIST_COLUMN_VISIBILITY,
            mergeVisibilityFromSaved: mergeChecklistColumnVisibilityFromSaved,
            applyVisibilityToTable: applyChecklistDataColumnVisibility,
            isRestoringRef: isRestoringChecklistRef,
        };
    }, [tabIndex, columnsVisible, columnsVisibleChecklist, columnsVisibleTechnicians]);

    const getActiveTable = useCallback(() => {
        if (tabIndex === 0) return refMaintTabulator.current;
        if (tabIndex === 2) return refTechniciansTabulator.current;
        return refChecklistTabulator.current;
    }, [tabIndex]);
    const refreshActiveTable = useCallback(() => {
        active.ref.current?.redraw?.(true);
    }, [active]);

    const restoreEmbeddedMaskToTable = useCallback((table, maskPage, mergeFn, applyFn, setColsVisible, isRestoringRef, canonicalFieldOrder) => {
        if (!table) return;
        const effective = getEffectiveMask(maskPage, state);
        if (effective?.type === 'user' && effective.userMask) {
            const m = effective.userMask;
            isRestoringRef.current = true;
            restoreCompanyListUserMaskToTable(table, m, {
                canonicalFieldOrder,
                setColumnsVisible: setColsVisible,
                clearHeaderFiltersWhenEmpty: true,
                applyColumnVisibilityFn: (tbl, jc, setVis) => {
                    const merged = mergeFn(jc);
                    setVis(merged);
                    applyFn(tbl, merged);
                },
            });
            const merged = mergeFn(safeParse(m.columns, {}));
            for (const field of Object.keys(merged)) {
                if (merged[field] === false) clearHeaderFilterForField(table, field);
            }
            setTimeout(() => { isRestoringRef.current = false; }, 0);
        } else if (effective?.type === 'standard' && effective.standardMask) {
            const m = effective.standardMask;
            isRestoringRef.current = true;
            const attributes = safeParse(m.attributes, []);
            const jsonColumns = safeParse(m.columns, {});
            applyCompanyListColumnLayout(table, attributes, canonicalFieldOrder);
            if (jsonColumns && typeof jsonColumns === 'object') {
                const merged = mergeFn(jsonColumns);
                setColsVisible(merged);
                applyFn(table, merged);
            }
            setTimeout(() => { isRestoringRef.current = false; }, 0);
        }
    }, [state]);

    const toolbarTabLabel = useMemo(() => {
        if (tabIndex === 0) return t('Maintenance.Tab.Tasks');
        if (tabIndex === 2) return t('Maintenance.Tab.Technicians');
        return t('Maintenance.Tab.Checklists');
    }, [tabIndex]);

    useEffect(() => {
        if(formMachine!=null){
            if(user.permissions?.includes("edit maintenance"))setScrollIcons(false);
        }
    },[formMachine]);

    useEffect(() => {
        const channel = getPusherChannel();
        const currentMachineId = formMachine?.id;
        if (!channel || currentMachineId == null || tabIndex !== 0) return;
        const refreshForMachine = (machineId) => {
            if (String(machineId) !== String(currentMachineId)) return;
            refetchMachineCards();
            getRequest(`/api/machine_cards/by_machine/${currentMachineId}`).then((r) => {
                const d = r?.data?.data ?? r?.data ?? r;
                if (d) setFormMachine(d);
            }).catch(() => {});
        };
        const onCreated = (data) => refreshForMachine(data?.machine_id);
        const onUpdated = (data) => refreshForMachine(data?.machine_id);
        const onDeleted = (data) => refreshForMachine(data?.machine_id);
        channel.bind('machine_card.created', onCreated);
        channel.bind('machine_card.updated', onUpdated);
        channel.bind('machine_card.deleted', onDeleted);
        return () => {
            channel.unbind('machine_card.created', onCreated);
            channel.unbind('machine_card.updated', onUpdated);
            channel.unbind('machine_card.deleted', onDeleted);
        };
    }, [formMachine?.id, tabIndex]);

    function getImages(id=null){
        getRequest(`/api/machine_cards/protocols/${id ? id :selectedCard.id}`).then((response) => {
            const data = response?.data;
            if (data != null && data !== "{}" && Array.isArray(data)) {
                setImages(data);
            } else {
                setImages([]);
            }
        }).catch(() => setImages([]));
    }

    function addNewMachineCard(){
        setMachineType([]);
        setMaintenanceTypes(allMaintenanceTypes);
        setSelectedCard(null);
        setImages([]);
        setShowMachineCardAdd(true);
    }

    function editNewMachineCard(){
        const row = ref.current.getSelectedData()[0];
        formikUpdate.setValues({
            ...row,
            lecturer_id: row?.lecturer_id ?? deriveLecturerIdFromContactId(row?.company_contact_id),
        });
        startFormikUpdate(row);
        getImages(row?.id);
        filterMaintenanceTypes(row?.maintenance_type.machine_type_id,row?.maintenance_type);
        setVisibleCard(true);
    }

    function hideEditCard(){
        formikUpdate.resetForm();
        setImages([]);
        setVisibleCard(false);
    }

    const onSelectRow = () => {
        setEditIcon(true);
        setCopyIcon(true);
        setDeleteIcon(true);
        setDeactivateIcon(true);
        setActivateIcon(true);
        if(ref.current.getSelectedData().length === 1){
            if(user.permissions?.includes("edit maintenance"))setEditIcon(false);
            if(user.permissions?.includes("delete maintenance") && ref.current.getSelectedData()[0]._children.length==0)setDeleteIcon(false);
            if(user.permissions?.includes("add maintenance")){
                if(ref.current.getSelectedData()[0].deactivation_date=="" || ref.current.getSelectedData()[0].deactivation_date==null)setDeactivateIcon(false);
                else setActivateIcon(false);
            }
            setSelectedCard(ref.current.getSelectedData()[0]);
        }
        else{
            var deactivated = 0;
            var activated = 0;
            ref.current.getSelectedData().forEach(item => {
                if(item.deactivation_date=="" || item.deactivation_date==null)activated++;
                else deactivated++;
            });
            if(!deactivated && activated)setDeactivateIcon(false);
            else if(deactivated && !activated)setActivateIcon(false);
        }
    }

    const validate = values => {
        const errors = {};
        /*if (!values.maintenance_type_id) {
            errors.maintenance_type_id = t('Common.RequiredField');
        }*/
        // ak chceš vyžadovať machine_part pri tomto pravidle, sprav ho povinným:
        // if (!values.machine_part?.trim()) errors.machine_part = t('Common.RequiredField');
        if (existsDuplicateCombo(values, null)) {
            errors.machine_part = t('Maintenance.Toast.TaskExistsForPart');
        }
        return errors;
}   ;

    const formik = useFormik({
        initialValues:{
           maintenance_type_id:'',initial_date:'',required_attachment:0,machine_part:'',responsible_employee_id:'',description:'',company_id:'',lecturer_id:'',company_contact_id:''
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            setDialogText(t('Common.SavingLower'));
            setVisible(true);
            let formData = new FormData();
            for (let value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }
            const mtAdd = getSelectedMaintenanceType(values.maintenance_type_id, null, maintenanceTypes, allMaintenanceTypes);
            if (mtAdd?.use_central_required_attachment) formData.set('required_attachment', '1');
            for(let i = 0;i<fileList.length;i++){
                formData.append('files[]',fileList[i]);
            }
            formData.append("machine_id", machine.id);
            postRequest('/api/machine_cards', formData,true)
            .then((response) => {
                refetchMachineCards();
                if (formMachine?.id) getRequest(`/api/machine_cards/by_machine/${formMachine.id}`).then((r) => { const d = r?.data?.data ?? r?.data ?? r; if (d) setFormMachine(d); });
                if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                formik.resetForm();
                if(fileList.length){
                    setFileList([]);
                    fileListRef.current.value = null;
                }
                setVisible(false);
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                setShowMachineCardAdd(false);
            }).catch((reason) => {
                setVisible(false);
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    const validateUpdate = values => {
        const errors = {};
        /*if (!values.maintenance_type_id) {
            errors.maintenance_type_id = t('Common.RequiredField');
        }*/
        if (existsDuplicateCombo(values, values.id)) {
            errors.machine_part = t('Maintenance.Toast.TaskExistsForPart');
        }
        return errors;
    };

    const formikUpdate = useFormik({
        initialValues: selectedCard ? {
            id: selectedCard?.id,maintenance_type_id:selectedCard?.maintenance_type_id,initial_date:selectedCard?.initial_date,deactivation_date:selectedCard?.deactivation_date,
            required_attachment:selectedCard?.required_attachment,machine_part:selectedCard?.machine_part,
            responsible_employee_id: selectedCard?.responsible_employee_id,
            description:selectedCard?.description,company_id:selectedCard?.company_id,
            lecturer_id: selectedCard?.lecturer_id ?? deriveLecturerIdFromContactId(selectedCard?.company_contact_id),
            company_contact_id:selectedCard?.company_contact_id} : 
            {maintenance_type_id:'',initial_date:'',deactivation_date:'',required_attachment:0,machine_part:'',responsible_employee_id:'',description:'',company_id:'',lecturer_id:'',company_contact_id:''},
        enableReinitialize:true,
        validate: validateUpdate,
        onSubmit: values => {
            setDialogText(t('Common.SavingLower'));
            setVisible(true);
            delete values.files;
            let formData = new FormData();
            for (let value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }
            const mtUpdate = getSelectedMaintenanceType(values.maintenance_type_id, null, maintenanceTypes, allMaintenanceTypes);
            if (mtUpdate?.use_central_required_attachment) formData.set('required_attachment', '1');
            for(let i = 0;i<updatefileList.length;i++){
                formData.append('files[]',updatefileList[i]);
            }
            formData.append("machine_id", machine.id);
            postRequest(`/api/machine_cards/update/${formikUpdate.values.id}`, formData,true)
            .then((response) => {
                if (formMachine?.id) getRequest(`/api/machine_cards/by_machine/${formMachine.id}`).then((r) => { if (r?.data) setFormMachine(r.data); });
                if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                setVisibleCard(false);
                formikUpdate.resetForm();
                if(updatefileList.length){
                    setUpdateFileList([]);
                    updateFileListRef.current.value = null;
                }
                setVisible(false);
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
            }).catch((reason) => {
                setVisible(false);
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    const formikDeactivation = useFormik({
        initialValues:{
           deactivation_date:''
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            setDialogText(t('Common.SavingLower'));
            setVisible(true);
            let rows_to_activate = [];
            rows_to_activate = ref.current.getSelectedData();
            let formData = new FormData();
            rows_to_activate.forEach((item) => {
                formData.append("cards[]",item.id);
            })
            formData.append("deactivation_date",values.deactivation_date);
            postRequest(`/api/machine_cards/deactivate`, formData,true)
            .then((response) => {
                setVisibleDeactivate(false);
                if (formMachine?.id) getRequest(`/api/machine_cards/by_machine/${formMachine.id}`).then((r) => { if (r?.data) setFormMachine(r.data); });
                setVisible(false);
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordsUpdatedDetail') });
            }).catch((reason) => {
                setVisible(false);
                setVisibleDeactivate(false);
                alert(reason);
                toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RecordUpdateFailedDetail'), life: 3000 });
            });
        },
    });

    const resetDetailUiOnNavigate = useCallback(() => {
        setVisibleCard(false);
        setShowMachineCardAdd(false);
        setVisibleDeactivate(false);
        setVisibleFavoritePicker(false);
        setFavoriteEditReplaceId(null);
        setFavoriteWizardCompanyId('');
        setFavoriteWizardLecturerId('');
        setFavoriteWizardContactId('');
        setSelectedCard(null);
        setImages([]);
        setFileList([]);
        setUpdateFileList([]);
        setEditIcon(true);
        setDeleteIcon(true);
        setCopyIcon(true);
        setDeactivateIcon(true);
        setActivateIcon(true);
        formik.resetForm();
        formikUpdate.resetForm();
    }, [formik, formikUpdate]);

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const applyMachine = (data) => {
            if (!data) return;
            resetDetailUiOnNavigate();
            currentMachineIdRef.current = data.id ?? null;
            setFormMachine(data);
        };
        const buildFetchRecord = (toParams = () => '') => async (direction, currentId) => {
            setDialogText?.(t('Common.Loading'));
            setVisible?.(true);
            try {
                const q = toParams();
                const url = `/api/machine_cards/navigate?direction=${direction}${currentId ? '&id=' + currentId : ''}${q ? '&' + q : ''}`;
                const resp = await getRequest(url);
                return resp?.data ?? null;
            } finally {
                setVisible?.(false);
            }
        };
        if (navigationContext?.filters != null || navigationContext?.sorters != null || navigationContext?.extra != null) {
            const toParams = () => navigationContextToQueryParams(navigationContext);
            return createAsyncNavigateHandlers(buildFetchRecord(toParams), applyMachine, () => currentMachineIdRef.current ?? formMachine?.id);
        }
        return createAsyncNavigateHandlers(buildFetchRecord(), applyMachine, () => currentMachineIdRef.current ?? formMachine?.id);
    }, [navigationContext, formMachine?.id, resetDetailUiOnNavigate, setDialogText, setVisible]);

    const handleFileChange = (event) => {
        setFileList(event.target.files);
    };

    const handleUpdateFileChange = (event) => {
        setUpdateFileList(event.target.files);
    };

    const acceptFiles = (id) => {
        getRequest(`/api/machine_cards/deleteProtocol/${id}`)
        .then((response) => {
            if (response?.status !== 200) {
                toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: response?.message || t('Common.Toast.FileDeleteFailedDetail'), life: 5000 });
                return;
            }
            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.FileDeletedDetail') });
            if (formMachine?.id) getRequest(`/api/machine_cards/by_machine/${formMachine.id}`).then((r) => { if (r?.data) setFormMachine(r.data); });
            getImages();
        }).catch((reason) => {
            const msg = reason?.response?.data?.message || reason?.message || t('Common.Toast.FileDeleteFailedDetail');
            toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: msg, life: 5000 });
        })
    };

    function deleteFiles(img){
        confirmDialog({
            message: t('Common.ConfirmDeleteFile'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept:reject,
            reject:() => acceptFiles(img.id)
        });
    }

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
    }

    const acceptActivate = () => {
        let rows_to_activate = [];
        rows_to_activate = ref.current.getSelectedData();
        let formData = new FormData();
        rows_to_activate.forEach((item) => {
            formData.append("cards[]",item.id);
        })
        postRequest(`/api/machine_cards/activate`, formData,true)
        .then((response) => {
            if (formMachine?.id) getRequest(`/api/machine_cards/by_machine/${formMachine.id}`).then((r) => { if (r?.data) setFormMachine(r.data); });
            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordsUpdatedDetail') });
        }).catch((reason) => {
            alert(reason);
            toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RecordUpdateFailedDetail'), life: 3000 });
        });
    }

    const confirmActivate = () => {
        confirmDialog({
            message: t('Maintenance.Confirm.ActivateTasks'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: acceptActivate
        });
    };

    const accept = () => {
        let rows_to_delete = [];
        rows_to_delete = ref.current.getSelectedData();
        rows_to_delete.forEach(element => {
          deleteRequest(`/api/machine_cards/${element.id}`)
          .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
            if (formMachine?.id) getRequest(`/api/machine_cards/by_machine/${formMachine.id}`).then((r) => { const d = r?.data?.data ?? r?.data; if (d) setFormMachine(d); });
          }).catch((reason) => {
              alert(reason);
              toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 }); 
          })
        }); 
      }

    const confirm = () => {
        confirmDialog({
            message: t('Common.ConfirmDeleteRecords'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            rejectClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            defaultFocus: 'accept',
            reject: accept,
            accept: reject
        });
    };

    const normalizeText = (value) => (value || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    function textHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        if (!headerValue) return true; // prázdny filter = zobraz všetko
        return normalizeText(rowValue).includes(normalizeText(headerValue));
    }

    function filterMaintenanceTypes(machine_type_id, maintenance = null) {
        setMachineType(machine_type_id);
        if (machine_type_id === "" || machine_type_id == null) {
            setMaintenanceTypes(allMaintenanceTypes || []);
            return;
        }
        const mtId = Number(machine_type_id);
        const list = (allMaintenanceTypes || []).filter(mt => {
            const typeId = Number(mt.machine_type?.id ?? mt.machine_type_id);
            return typeId === mtId;
        });
        // Pri úprave zařaď do zoznamu aktuálny úkon, aby sa v selecte zobrazil
        if (maintenance?.id && !list.some(m => Number(m.id) === Number(maintenance.id))) {
            setMaintenanceTypes([...list, maintenance]);
            return;
        }
        setMaintenanceTypes(list);
    }

    const getMachineCardsForCurrentMachine = () => {
        const entry = (machineCards ?? []).find(c => String(c.id) === String(formMachine?.id));
        return entry?.machine_card || [];
    };

    // odporúčam kontrolovať iba aktívne; ak chceš aj deaktivované, odstráň túto podmienku
    const isActiveCard = (row) => !row?.deactivation_date;

    const existsDuplicateCombo = (values, excludeId = null) => {
        const typeId = String(values?.maintenance_type_id ?? "");
        const part = normalizeText(values?.machine_part);

        if (!typeId) return false;

        const rows = getMachineCardsForCurrentMachine();

        return rows.some(r => {
            if (excludeId != null && String(r.id) === String(excludeId)) return false;
            if (!isActiveCard(r)) return false; // voliteľné
            return String(r.maintenance_type_id) === typeId && normalizeText(r.machine_part) === part;
        });
    };

    function maintenanceTypeHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        if (!headerValue) return true; // nič nezadané = nič nefiltruj
        const cellValue = rowData?.maintenance_type?.name || "";
        return normalizeText(cellValue).includes(normalizeText(headerValue));
    }

      function InitialDate(props) {
        const rowData = props.cell.getRow().getData();
        return rowData?.initial_date ? DateTime.fromISO(rowData.initial_date).toFormat(dateFmt) : "";
      }

      function DeactivationDate(props) {
        const rowData = props.cell.getRow().getData();
        return rowData?.deactivation_date ? DateTime.fromISO(rowData.deactivation_date).toFormat(dateFmt) : t('Common.ActivePlural');
      }

      function onEditRow(machine_card){
        formikUpdate.setValues({
            ...machine_card,
            lecturer_id: machine_card?.lecturer_id ?? deriveLecturerIdFromContactId(machine_card?.company_contact_id),
        });
        setSelectedCard(machine_card);
        startFormikUpdate(machine_card);
        getImages(machine_card?.id);
        filterMaintenanceTypes(machine_card.maintenance_type.machine_type_id,machine_card.maintenance_type);
        setVisibleCard(true);
      };
      
      function EditRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
      }
      
    function dateHeaderFilter(headerValue, rowValue, rowData, filterParams){
        if (!headerValue) return true;

        if (filterParams.name === "initial_date") {
            if (!rowData?.initial_date) return false;
            return DateTime
                .fromISO(rowData.initial_date)
                .toFormat(dateFmt)
                .includes(headerValue);
        } else {
            if (!rowData?.deactivation_date && !rowValue) {
                // špeciálny text t('Common.ActivePlural')
                return normalizeText("Aktívne").includes(normalizeText(headerValue));
            }
            if (!rowData?.deactivation_date) return false;
            return DateTime
                .fromISO(rowData.deactivation_date)
                .toFormat(dateFmt)
                .includes(headerValue);
        }
    }

    /** Efektívna zodpovedná (z typu pri use_central_responsible_person, inak z karty) – pre filter. */
    function getEffectiveResponsibleName(rowData) {
        const mt = rowData?.maintenance_type;
        if (mt?.use_central_responsible_person) return mt?.responsible?.name ?? '';
        return rowData?.responsible?.name ?? '';
    }

    /** Efektívna servisná firma (z typu pri centrálnej, inak z karty) – pre filter. */
    function getEffectiveCompanyName(rowData) {
        const mt = rowData?.maintenance_type;
        if (mt?.use_central_service_person && (mt?.central_company_id || mt?.central_company_contact_id)) {
            return mt?.centralCompany?.name || mt?.central_company?.name || '';
        }
        return rowData?.company?.name ?? '';
    }

    /** Efektívny druh technika (label) – pre filter. */
    function getEffectiveLecturerLabel(rowData) {
        const mt = rowData?.maintenance_type;
        if (mt?.use_central_service_person && (mt?.central_company_id || mt?.central_company_contact_id)) {
            return (mt?.centralCompanyContact?.employee_id != null || mt?.central_company_contact?.employee_id != null) ? t('Common.InternalEmployeeLower') : t('Common.ServiceCompanyEmployee');
        }
        return getLecturerLabelFromRow(rowData, effectiveMaintenanceCompanyContacts) || '';
    }

    /** Efektívny servisný technik (meno) – pre filter. */
    function getEffectiveContactName(rowData) {
        const mt = rowData?.maintenance_type;
        if (mt?.use_central_service_person && (mt?.central_company_id || mt?.central_company_contact_id)) {
            return mt?.centralCompanyContact?.employee?.name || mt?.centralCompanyContact?.name || mt?.central_company_contact?.employee?.name || mt?.central_company_contact?.name || '';
        }
        const cc = getCompanyContactFromRow(rowData);
        if (!cc) return '';
        return (cc.employee_id != null ? (cc?.employee?.name || '') : (cc?.name || '')) || '';
    }

    function responsibleHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue) return true;
        const name = getEffectiveResponsibleName(rowData);
        return normalizeText(name).includes(normalizeText(headerValue));
    }

    function companyHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue) return true;
        const name = getEffectiveCompanyName(rowData);
        return normalizeText(name).includes(normalizeText(headerValue));
    }

    function lecturerHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue) return true;
        const label = getEffectiveLecturerLabel(rowData);
        if (!label) return false;
        return normalizeText(label).includes(normalizeText(headerValue));
    }

    function ServisnaFirmaInTable(props) {
        const rowData = props.cell.getRow().getData();
        const mt = rowData?.maintenance_type;
        if (mt?.use_central_service_person && (mt?.central_company_id || mt?.central_company_contact_id)) {
            const companyName = mt?.centralCompany?.name || mt?.central_company?.name || '';
            return <>{companyName}</>;
        }
        return <>{rowData?.company?.name ?? ''}</>;
    }

    function ZodpovednyFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const mt = rowData?.maintenance_type;
        if (mt?.use_central_responsible_person) {
            return <>{mt?.responsible?.name ?? ''}</>;
        }
        return <>{rowData?.responsible?.name ?? ''}</>;
    }

    function LecturerName(props) {
        const rowData = props.cell.getRow().getData();
        const mt = rowData?.maintenance_type;
        if (mt?.use_central_service_person && (mt?.central_company_id || mt?.central_company_contact_id)) {
            return (mt?.centralCompanyContact?.employee_id != null || mt?.central_company_contact?.employee_id != null) ? t('Common.InternalEmployeeLower') : t('Common.ServiceCompanyEmployee');
        }
        const label = getLecturerLabelFromRow(rowData, effectiveMaintenanceCompanyContacts);
        return label; // môže byť aj ""
    }
    
    function getCompanyContactFromRow(rowData) {
        if (rowData?.company_contact) return rowData.company_contact;
        const id = rowData?.company_contact_id;
        if (!id) return null;
        return effectiveMaintenanceCompanyContacts.find(c => String(c.id) === String(id)) || null;
    }

    function ContactName(props) {
        const rowData = props.cell.getRow().getData();
        const mt = rowData?.maintenance_type;
        if (mt?.use_central_service_person && (mt?.central_company_id || mt?.central_company_contact_id)) {
            const name = mt?.centralCompanyContact?.employee?.name || mt?.centralCompanyContact?.name || mt?.central_company_contact?.employee?.name || mt?.central_company_contact?.name;
            return name || "";
        }
        const cc = getCompanyContactFromRow(rowData);
        if (!cc) return "";
        return cc.employee_id != null ? (cc?.employee?.name || "") : (cc?.name || "");        
    }

    function contactHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue) return true;
        const name = getEffectiveContactName(rowData);
        return normalizeText(name).includes(normalizeText(headerValue));
    }

    function Protocol(props) {
        const rowData = props.cell.getRow().getData();
        const files = rowData.files ?? rowData.scheduled_files ?? [];
        return files.length ? <div className='flex flex-row'>{files.map((img) => (<a key={img.id} style={{color:'blue',cursor:'pointer',marginBottom:'2px',width: '24px',display: 'block'}} onClick={() => {viewFile(img.id);}}><PaperClipIcon/></a>))}</div> : null;
    }

    function RequiredAttachmentFormatter(props) {
        const rowData = props.cell.getRow().getData();
        // 0/1 môže prísť ako number aj string
        const raw = rowData?.required_attachment;
        const value = Number(raw) === 1 ? 1 : 0;
        return (
            <div className="w-full">
            {value === 1 ? t('Common.Yes') : t('Common.No')}
            </div>
        );
    }

    const dateTimeFmt = `${dateFmt} HH:mm`;

    function idHeaderFilter(headerValue, rowValue) {
        if (!headerValue) return true;
        return normalizeText(String(rowValue ?? '')).includes(normalizeText(headerValue));
    }

    const auditTailColumns = useMemo(
        () => buildAuditTabulatorColumns({
            includeId: false,
            dateFormat: dateFmt,
            dateTimeFormat: dateTimeFmt,
            getUserColor,
            getUserInitials,
            textHeaderFilter: idHeaderFilter,
            remotePassthrough: false,
        }),
        [dateFmt, dateTimeFmt, getUserColor, getUserInitials]
    );

    const columns = useMemo(() => [
        {
            title: '',
            field: 'rowSelection',
            formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            hozAlign: 'center',
            width: 44,
            headerSort: false,
            resizable: false,
            frozen: true,
            print: false,
            download: false,
        },
        {
            title: '',
            field: 'editor',
            hozAlign: 'center',
            width: 44,
            minWidth: 44,
            headerSort: false,
            formatter: reactFormatter(<EditRowFormatter />),
            resizable: false,
            frozen: true,
            print: false,
            download: false,
        },
        {
            title: 'ID',
            field: 'id',
            headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false,
            headerFilterFunc: idHeaderFilter,
            minWidth: TABULATOR_LIST_ID_MIN_WIDTH,
            widthGrow: 1,
            sorter: 'number',
            hozAlign: 'left',
        },
        { title: t('Common.TaskName'), field: 'maintenance_type.name', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: maintenanceTypeHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.TaskName')), widthGrow: 1 },
        { title: t('Common.InitialPerformance'), field: 'initial_date', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.InitialPerformance')), widthGrow: 1, formatter: reactFormatter(<InitialDate />), headerFilterFunc: dateHeaderFilter, headerFilterFuncParams: { name: 'initial_date' } },
        { title: t('Common.Deactivation'), field: 'deactivation_date', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Deactivation')), widthGrow: 1, formatter: reactFormatter(<DeactivationDate />), headerFilterFunc: dateHeaderFilter, headerFilterFuncParams: { name: 'deactivation_date' } },
        { title: t('Common.Description'), field: 'description', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Description')), widthGrow: 1 },
        { title: t('Common.MachinePart'), field: 'machine_part', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.MachinePart')), widthGrow: 1 },
        {
            title: t('Common.RequiredAttachment'),
            field: 'required_attachment',
            minWidth: tabulatorColumnMinWidthFromTitle(t('Common.RequiredAttachment'), 'multiselect'),
            widthGrow: 1,
            formatter: reactFormatter(<RequiredAttachmentFormatter />),
            headerFilter: 'select',
            headerFilterParams: { values: { '': t('Common.FilterAll'), '1': t('Common.Yes'), '0': t('Common.No') } },
            headerFilterFunc: (headerValue, rowValue) => {
                if (headerValue === '' || headerValue == null) return true;
                return String(Number(rowValue) === 1 ? 1 : 0) === String(headerValue);
            },
        },
        { title: 'Predloha', field: 'scheduled_files', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: () => true, minWidth: tabulatorColumnMinWidthFromTitle('Predloha'), widthGrow: 1, formatter: reactFormatter(<Protocol />) },
        { title: 'Serv. firma', field: 'company.name', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: companyHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle('Serv. firma'), widthGrow: 1, formatter: reactFormatter(<ServisnaFirmaInTable />) },
        { title: 'Druh technika', field: 'custom_lecturer_name', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: lecturerHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle('Druh technika'), widthGrow: 1, formatter: reactFormatter(<LecturerName />) },
        { title: t('Common.ServiceTechnician'), field: 'custom_contact_name', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: contactHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.ServiceTechnician')), widthGrow: 1, formatter: reactFormatter(<ContactName />) },
        { title: t('Common.TaskType'), field: 'maintenance_type.type', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.TaskType')), widthGrow: 1 },
        { title: t('Common.Norm'), field: 'maintenance_type.norm', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Norm')), widthGrow: 1 },
        { title: t('Common.IntervalMonths'), field: 'maintenance_type.interval_months', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.IntervalMonths')), widthGrow: 1 },
        { title: t('Common.ResponsibleShort'), field: 'responsible.name', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: responsibleHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.ResponsibleShort')), widthGrow: 1, formatter: reactFormatter(<ZodpovednyFormatter />) },
        { title: t('Common.TaskDescription'), field: 'maintenance_type.description', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.TaskDescription')), widthGrow: 1 },
        ...auditTailColumns,
    ], [auditTailColumns]);

    function TechNameFormatter(props) {
        const d = props.cell.getRow().getData();
        return <>{d?.employee_id ? (d?.employee?.name ?? d?.name ?? '') : (d?.name ?? '')}</>;
    }
    function TechTelFormatter(props) {
        const d = props.cell.getRow().getData();
        return <>{d?.employee_id ? (d?.employee?.tel_number ?? d?.tel_number ?? '') : (d?.tel_number ?? '')}</>;
    }
    function TechEmailFormatter(props) {
        const d = props.cell.getRow().getData();
        return <>{d?.employee_id ? (d?.employee?.email ?? d?.email ?? '') : (d?.email ?? '')}</>;
    }

    function openFavoriteTechnicianEdit(rowData) {
        if (!user.permissions?.includes('edit maintenance')) return;
        setFavoritePickerIds(favoriteContactsFromApiRef.current.map((c) => c.id));
        setFavoriteEditReplaceId(rowData.id);
        setFavoriteWizardCompanyId(String(rowData.company_id ?? ''));
        const cc = effectiveMaintenanceContactsRef.current.find((c) => String(c.id) === String(rowData.id));
        const lec = cc ? (cc.employee_id != null ? '1' : '0') : '';
        setFavoriteWizardLecturerId(lec === '' ? '' : lec);
        setFavoriteWizardContactId(String(rowData.id));
        setVisibleFavoritePicker(true);
    }

    function EditFavoriteTechnicianFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const can = user.permissions?.includes('edit maintenance');
        return (
            <div className="flex items-center justify-center w-full h-full">
                <button
                    type="button"
                    disabled={!can}
                    className={!can ? 'opacity-25 cursor-not-allowed' : ''}
                    onClick={() => { if (can) openFavoriteTechnicianEdit(rowData); }}
                    title={t('Maintenance.EditServiceTechnician')}
                >
                    <EditRowIcon />
                </button>
            </div>
        );
    }

    function technicianTypeHeaderFilter(headerValue, rowValue) {
        if (!headerValue || String(headerValue).trim() === '') return true;
        const selected = new Set(String(headerValue).split(',').map((s) => s.trim()).filter(Boolean));
        return selected.has(String(rowValue ?? '').trim());
    }

    const columnsTechnicians = useMemo(() => [
        {
            title: '',
            field: 'rowSelection',
            formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            hozAlign: 'center',
            width: 44,
            headerSort: false,
            resizable: false,
            frozen: true,
            print: false,
            download: false,
        },
        {
            title: '',
            field: 'editor',
            hozAlign: 'center',
            width: 44,
            minWidth: 44,
            headerSort: false,
            formatter: reactFormatter(<EditFavoriteTechnicianFormatter />),
            resizable: false,
            frozen: true,
            print: false,
            download: false,
        },
        {
            title: 'ID',
            field: 'id',
            headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false,
            headerFilterFunc: idHeaderFilter,
            minWidth: TABULATOR_LIST_ID_MIN_WIDTH,
            widthGrow: 1,
            sorter: 'number',
            hozAlign: 'left',
        },
        { title: t('Common.ServiceCompany'), field: 'company_name', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.ServiceCompany')), widthGrow: 1 },
        { title: t('Common.ServiceTechnician'), field: 'name', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.ServiceTechnician')), widthGrow: 1, formatter: reactFormatter(<TechNameFormatter />) },
        { title: t('Common.Column.Phone'), field: 'tel_number', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Column.Phone')), formatter: reactFormatter(<TechTelFormatter />) },
        { title: 'Email', field: 'email', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle('Email'), formatter: reactFormatter(<TechEmailFormatter />) },
        { title: t('Common.Description'), field: 'description', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Description')) },
        {
            title: 'Typ technika',
            field: 'technician_type',
            headerFilter: primeMultiSelectHeaderFilter,
            headerFilterParams: {
                placeholder: 'Typ technika',
                valueType: 'string',
                options: [
                    { label: t('Common.InternalEmployee'), value: "Interný zamestnanec" },
                    { label: t('Common.ServiceCompanyEmployee'), value: "Zamestnanec servisnej firmy" },
                ],
            },
            headerFilterFunc: technicianTypeHeaderFilter,
            minWidth: tabulatorColumnMinWidthFromTitle('Typ technika', 'multiselect'),
            widthGrow: 1,
        },
        ...auditTailColumns,
    ], [auditTailColumns]);

    const onSelectRowTechnicians = () => {
        const sel = refTechnicians.current?.getSelectedData?.() ?? [];
        const can = user.permissions?.includes('edit maintenance');
        setDeleteTechnicianIcon(!(can && sel.length > 0));
        setEditTechnicianIcon(!(can && sel.length === 1));
    };

    const refreshTechnicians = () => {
        getRequest('/api/company_contacts?minimal=1&module=maintenance')
            .then((r) => {
                const list = r?.data ?? r ?? [];
                dispatch({ type: 'load_company_contacts', newCompanyContacts: list });
            })
            .catch(() => {});
        loadFavoriteMaintenanceContacts();
    };

    const acceptRemoveFromFavorites = () => {
        const rows = refTechnicians.current?.getSelectedData?.() ?? [];
        const removeIds = new Set(rows.map((r) => String(r.id)));
        const newIds = favoriteContactsFromApi.filter((c) => !removeIds.has(String(c.id))).map((c) => c.id);
        if (!formMachine?.id) return;
        setDialogText(t('Common.SavingLower'));
        setVisible(true);
        putRequest(`/api/machines/${formMachine.id}/favorite-maintenance-contacts`, { company_contact_ids: newIds })
            .then((r) => {
                const list = r?.data ?? [];
                setFavoriteContactsFromApi(Array.isArray(list) ? list : []);
                setVisible(false);
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.FavoritesUpdated') });
            })
            .catch(() => {
                setVisible(false);
                toast?.current?.show({ severity: 'warn', summary: t('Common.Error'), life: 3000, detail: t('Common.Toast.SaveFailedDetail') });
            });
    };

    const confirmRemoveFromFavorites = () => {
        confirmDialog({
            message: t('Maintenance.Confirm.RemoveFavoriteTechnicians'),
            header: 'Potvrdenie',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: acceptRemoveFromFavorites,
            reject: () => toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), life: 3000 }),
        });
    };

    const resetFavoriteWizard = () => {
        setFavoriteEditReplaceId(null);
        setFavoriteWizardCompanyId('');
        setFavoriteWizardLecturerId('');
        setFavoriteWizardContactId('');
    };

    const onFavoriteWizardCompanyChange = (company_id) => {
        setFavoriteWizardCompanyId(company_id || '');
        setFavoriteWizardLecturerId('');
        setFavoriteWizardContactId('');
    };

    const onFavoriteWizardLecturerChange = (lecturer_id) => {
        setFavoriteWizardLecturerId(lecturer_id === '' ? '' : String(lecturer_id));
        setFavoriteWizardContactId('');
    };

    const saveFavoritePicker = () => {
        if (!formMachine?.id) return;
        let ids = Array.isArray(favoritePickerIds) ? favoritePickerIds.map((id) => Number(id)) : [];
        if (favoriteEditReplaceId != null && favoriteEditReplaceId !== '') {
            ids = ids.filter((x) => Number(x) !== Number(favoriteEditReplaceId));
        }
        if (favoriteWizardContactId) {
            const nid = Number(favoriteWizardContactId);
            if (!Number.isNaN(nid) && !ids.includes(nid)) ids = [...ids, nid];
        }
        setDialogText(t('Common.SavingLower'));
        setVisible(true);
        putRequest(`/api/machines/${formMachine.id}/favorite-maintenance-contacts`, { company_contact_ids: ids })
            .then((r) => {
                const list = r?.data ?? [];
                setFavoriteContactsFromApi(Array.isArray(list) ? list : []);
                setVisibleFavoritePicker(false);
                resetFavoriteWizard();
                setVisible(false);
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.FavoritesSaved') });
            })
            .catch(() => {
                setVisible(false);
                toast?.current?.show({ severity: 'warn', summary: t('Common.Error'), life: 3000, detail: t('Common.Toast.SaveFailedDetail') });
            });
    };

      const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const [expandedKeys, setExpandedKeys] = useState({});
    
      const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
        }
      };
    
    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    function changeCompany(company_id){
        const filtered = effectiveMaintenanceCompanyContacts.filter(
            contact => String(contact.company_id) === String(company_id)
        );
        if (visibleCard) {
            formikUpdate.setFieldValue('company_id', company_id);
            setCompanyContacts(filtered);
            formikUpdate.setFieldValue('lecturer_id', '');
            formikUpdate.setFieldValue('company_contact_id', '');
        } else {
            formik.setFieldValue('company_id', company_id);
            setCompanyContacts(filtered);
            formik.setFieldValue('lecturer_id', '');
            formik.setFieldValue('company_contact_id', '');
        }
    }

    const LECTURER_EXTERNAL = t('Common.ServiceCompanyEmployee');
    const LECTURER_INTERNAL = t('Common.InternalEmployee');

    const lecturers = [
        { id: 0, name: LECTURER_EXTERNAL },
        { id: 1, name: LECTURER_INTERNAL },
    ];

    function getLecturerLabelFromContact(companyContact) {
        if (!companyContact) return "";
        return companyContact?.employee_id != null ? LECTURER_INTERNAL : LECTURER_EXTERNAL;
    }

    function getLecturerLabelFromRow(rowData, allContacts = []) {
        // 1) preferuj eager-loaded objekt
        if (rowData?.company_contact) return getLecturerLabelFromContact(rowData.company_contact);
        // 2) fallback: ak máš iba company_contact_id, nájdi ho v store
        const id = rowData?.company_contact_id;
        if (!id) return "";
        const found = allContacts.find(c => String(c.id) === String(id));
        return getLecturerLabelFromContact(found);
    }

    function changeLecturer(lecturer_id){
        const lec = lecturer_id === "" || lecturer_id == null ? "" : Number(lecturer_id);
        if (visibleCard) {
            formikUpdate.setFieldValue('lecturer_id', lecturer_id);
            const companyId = formikUpdate.values?.company_id;
            const base = effectiveMaintenanceCompanyContacts.filter(c => String(c.company_id) === String(companyId));
            const filtered = lec === "" ? base : lec === 1 ? base.filter(c => c.employee_id != null) : base.filter(c => c.employee_id == null);
            setCompanyContacts(filtered);
            formikUpdate.setFieldValue('company_contact_id', '');
        } else {
            formik.setFieldValue('lecturer_id', lecturer_id);
            const companyId = formik.values?.company_id;
            const base = effectiveMaintenanceCompanyContacts.filter(c => String(c.company_id) === String(companyId));
            const filtered = lec === "" ? base : lec === 1 ? base.filter(c => c.employee_id != null) : base.filter(c => c.employee_id == null);
            setCompanyContacts(filtered);
            formik.setFieldValue('company_contact_id', '');
        }
    }

    function deriveLecturerIdFromContactId(company_contact_id) {
        if (!company_contact_id) return "";
        const cc = effectiveMaintenanceCompanyContacts.find(c => String(c.id) === String(company_contact_id));
        if (!cc) return "";
        return cc.employee_id != null ? 1 : 0;
    }

    function startFormikUpdate(selectedCard){
        const companyId = selectedCard?.company_id;
        const base = effectiveMaintenanceCompanyContacts.filter(c => String(c.company_id) === String(companyId));
        // ak záznam nemá lecturer_id (alebo chceš prepočítať), dopočítaj z company_contact_id
        const derived = deriveLecturerIdFromContactId(selectedCard?.company_contact_id);
        // POZOR: setValues sa u teba volá až po startFormikUpdate, tak tu nastav fieldValue až po tom,
        // najjednoduchšie to urob tak, že zmeníš poradie volania (nižšie).
        setCompanyContacts(
            derived === "" ? base :
            derived === 1 ? base.filter(c => c.employee_id != null) :
                            base.filter(c => c.employee_id == null)
        );
    }

    // Pri zmene selectedCard vždy nastavíme companyContacts podľa company_id a lecturer_id, aby sa v edit forme zobrazil Servisný technik
    useEffect(() => {
        if (!selectedCard?.company_id) return;
        const companyId = selectedCard.company_id;
        const base = effectiveMaintenanceCompanyContacts.filter(c => String(c.company_id) === String(companyId));
        const derived = deriveLecturerIdFromContactId(selectedCard.company_contact_id);
        setCompanyContacts(
            derived === "" ? base :
            derived === 1 ? base.filter(c => c.employee_id != null) :
                            base.filter(c => c.employee_id == null)
        );
    }, [selectedCard?.id, selectedCard?.company_id, selectedCard?.company_contact_id, effectiveMaintenanceCompanyContacts]);

    function viewFile(file_id){
        getRequest(`/api/machine_cards/protocol/${file_id}`).then((response) => {
            const d = response.data;
            if (d?.url) openFilePreview({ url: d.url, filename: d.filename || 'súbor' });
        });
    }

    const checklistTemplatesForMachine = React.useMemo(() => {
        const mid = formMachine?.id;
        if (!mid) return [];

        return (state.checklist_templates || []).filter(t =>
            String(t?.machine_id ?? t?.machine?.id) === String(mid)
        );
    }, [state.checklist_templates, formMachine?.id]);

    function removeDiacritics(str) {
        return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    
    const extractDepartmentsFromRecipients = (recipients) => {
          const departmentMap = new Map();
    
          recipients.forEach((user) => {
              const dept = user?.employee?.department;
              if (dept && !departmentMap.has(dept.id)) {
              departmentMap.set(dept.id, {
                  id: dept.id,
                  name: dept.name,
                  searchLabel: removeDiacritics(dept.name).toLowerCase(),
              });
              }
          });
    
          return Array.from(departmentMap.values());
      };
    
    function DepartmentFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return extractDepartmentsFromRecipients(rowData?.users).map(departmnent => departmnent?.name).join(', ')
    }
    
    function departmentFilter(headerValue, rowValue, rowData, filterParams) {
      if (!headerValue) return true;
    
      const normalizedSearch = removeDiacritics(headerValue).toLowerCase();
    
      return rowData?.users?.some(user => {
        const dept = user?.employee?.department_id;
        if (!dept) return false;
        let found = state?.departments.find(department => department?.id == dept);
        return removeDiacritics(found?.name).toLowerCase().includes(normalizedSearch);
      });
    }
    
    function UserFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return rowData.users.map((user) => {
            return <Avatar title={user?.employee?.name || user?.username} label={getUserInitials(user?.employee?.name || user?.username)} shape="circle" style={{ backgroundColor: getUserColor(user?.username), color: '#ffffff',marginRight: '5px'}} />;
        });
    }
    
    function userFilter(headerValue, rowValue, rowData, filterParams) {
      if (!headerValue) return true;
    
      const normalizedSearch = removeDiacritics(headerValue).toLowerCase();
    
      return rowData?.users?.some(user => {
        const dept = user?.employee?.name || user?.username;
        if (!dept) return false;
        return removeDiacritics(dept).toLowerCase().includes(normalizedSearch);
      });
    }
    
      function ManagerFormatter(props) {
          const rowData = props.cell.getRow().getData();
          return <Avatar title={rowData?.manager?.employee?.name || rowData?.manager?.username} label={getUserInitials(rowData?.manager?.employee?.name || rowData?.manager?.username)} shape="circle" style={{ backgroundColor: getUserColor(rowData?.manager?.username), color: '#ffffff',marginRight: '5px'}} />;
    
      }
    
      function managerHeaderFilter(search, rowValue, rowData) {
        if (!search) return true;
    
        const managerName =  rowData?.manager?.employee?.name || rowData?.manager?.username || '';
        const normName = removeDiacritics(managerName.toLowerCase());
        const normSearch = removeDiacritics(search.toLowerCase());
    
        return normName.includes(normSearch);
      }
    
        function formatIntensityText(value) {
          if (!value) return "";
    
          let data;
          try {
            data = typeof value === "string" ? JSON.parse(value) : value;
          } catch {
            return "";
          }
    
          const intensity = data.intensity || "";
          const time = data.time || "";
    
          const specialDaysMap = {
            first_monday: t('Maintenance.Schedule.FirstMonday'),
            first_tuesday: t('Maintenance.Schedule.FirstTuesday'),
            first_wednesday: t('Maintenance.Schedule.FirstWednesday'),
            first_thursday: t('Maintenance.Schedule.FirstThursday'),
            first_friday: t('Maintenance.Schedule.FirstFriday'),
            last_monday: t('Maintenance.Schedule.LastMonday'),
            last_tuesday: t('Maintenance.Schedule.LastTuesday'),
            last_wednesday: t('Maintenance.Schedule.LastWednesday'),
            last_thursday: t('Maintenance.Schedule.LastThursday'),
            last_friday: t('Maintenance.Schedule.LastFriday'),
          };
    
          // 1=Mon ... 7=Sun (podľa príkladu so "1","3","5")
          const dayNames = {
            1: "Pondelok",
            2: "Utorok",
            3: "Streda",
            4: "Štvrtok",
            5: "Piatok",
            6: "Sobota",
            7: "Nedeľa",
          };
    
          const joinList = (arr) =>
            (Array.isArray(arr) ? arr : [arr])
              .filter((v) => v !== undefined && v !== null && String(v).trim() !== "")
              .map((v) => String(v).trim())
              .join(",");
    
          switch (intensity) {
            case "denne":
              return `Denne/${time}`;
    
            case "tyzdenne": {
              const days = Array.isArray(data.daysOfWeek) ? data.daysOfWeek : [];
              const daysStr = days
                .map((d) => {
                  const n = Number(d);
                  return dayNames[n] || String(d);
                })
                .join(",");
              return t('Common.Schedule.WeeklyPath', { days: daysStr, time });
            }
    
            case "mesacne": {
              if (data.dayMonth && typeof data.dayMonth === "string") {
                // starší typ – špeciálne dni (first_monday, ...)
                const label = specialDaysMap[data.dayMonth] || data.dayMonth;
                return t('Common.Schedule.MonthlyPath', { part: label, time });
              } else if (Array.isArray(data.daysOfMonth) && data.daysOfMonth.length) {
                // nový formát – zoznam dní v mesiaci bez "deň"
                const daysStr = data.daysOfMonth.map((d) => Number(d)).join(",");
                return t('Common.Schedule.MonthlyPath', { part: daysStr, time });
              } else if (data.dayMonth && typeof data.dayMonth === "object") {
                // fallback – ak by niekto omylom poslal {day,month} pre mesačne
                const d = Number(data.dayMonth.day || "");
                return Number.isFinite(d) ? t('Common.Schedule.MonthlyPath', { part: d, time }) : t('Common.Schedule.MonthlyTimeOnly', { time });
              }
              return t('Common.Schedule.MonthlyTimeOnly', { time });
            }
    
            case "rocne": {
              // očakávame objekt: { day, month }
              const dm = data.dayMonth || {};
              const day = Number(dm.day || data.day || "");
              const month = Number(dm.month || data.month || "");
              const dayStr = Number.isFinite(day) ? String(day) : "";
              const monthStr = Number.isFinite(month) ? String(month) : "";
              const datePart =
                dayStr && monthStr ? `${dayStr}.${monthStr}` : `${dayStr || monthStr}`;
              return t('Common.Schedule.YearlyPath', { date: datePart, time });
            }
    
            case "viackrat_den": {
              const times = joinList(data.times || data.timesDaily || []);
              return t('Common.Schedule.MultipleDailyPath', { times });
            }
    
            case "nahodne":
              return t('Common.RandomUntil', { time });
    
            default:
              return intensity || "";
          }
        }
    
        function IntensityFormatter({ cell }) {
            const value = cell.getValue();
            return formatIntensityText(value);
        }
    
        function intensityHeaderFilter(headerValue, rowValue) {
          if (!headerValue) return true;
    
          const formatted = formatIntensityText(rowValue);
          const normFormatted = removeDiacritics(formatted.toLowerCase());
          const normSearch = removeDiacritics(headerValue.toLowerCase());
    
          return normFormatted.includes(normSearch);
        }
    
        function diacriticInsensitiveFilter(headerValue, rowValue) {
            if (!headerValue) return true;
            if (!rowValue) return false;
            const normalize = str =>
                str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
            return normalize(rowValue.toString()).includes(normalize(headerValue.toString()));
        }
    
        const notifBeforeOptions = [
          { label: "1 hodina pred", value: "1 hours" },
          { label: "2 hodiny pred", value: "2 hours" },
          { label: "4 hodiny pred", value: "4 hours" },
          { label: t('Common.Notify.Hours6Before'), value: "6 hours" },
          { label: t('Common.Notify.Day1Before'), value: "1 days" },
          { label: "2 dni pred", value: "2 days" },
          { label: "3 dni pred", value: "3 days" },
          { label: t('Common.Notify.Days5Before'), value: "5 days" },
          { label: t('Common.Notify.Days7Before'), value: "7 days" },
          { label: t('Common.Notify.Days10Before'), value: "10 days" },
          { label: t('Common.Notify.Days14Before'), value: "14 days" },
          { label: t('Common.Notify.Days30Before'), value: "30 days" },
        ];
    
        function getLabelFromValue(value) {
          const option = notifBeforeOptions.find(opt => opt.value === value);
          return option ? option.label : value || '';
        }
    
        // Formatter pre React Tabulator
        function NotifBeforeFormatter(props) {
          try {
            const rowData = props.cell.getRow().getData();
            const parsedData = JSON.parse(rowData?.sending_data || '{}');
            const notifRaw = parsedData?.notification_before;
    
            if (!notifRaw) return '';
    
            const values = notifRaw.map(v => v.trim());
            console.log(values);
            const labels = values.map(getLabelFromValue);
    
            return labels.join('/');
          } catch (e) {
            console.error('Invalid JSON in data field:', e);
            return '';
          }
        }
    
      // Filter pre React Tabulator
    function notifBeforeHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue) return true;
        try {
            const parsed = JSON.parse(rowData?.sending_data || "{}");
            const raw = parsed?.notification_before;

            const arr = Array.isArray(raw) ? raw : raw ? [raw] : [];
            const labels = arr
            .map(v => getLabelFromValue(String(v).trim()))
            .join("/");

            return removeDiacritics(labels.toLowerCase()).includes(removeDiacritics(headerValue.toLowerCase()));
        } catch {
            return false;
        }
    }
    
      function ActiveFormatter({ cell }) {
        const value = cell.getValue();
        return (
          <span className={value === 1 ? "text-green-600 font-semibold" : "text-red-600 font-semibold"}>
            {value === 1 ? "Aktívny" : t('Common.Inactive')}
          </span>
        );
      }
    
      function activeHeaderFilter(headerValue, rowValue) {
        if (headerValue === undefined || headerValue === "" || headerValue === null) {
        return true; // nič nezadané = všetko ukáž
      }
    
      if (headerValue === "Aktívny") {
        return rowValue === 1;
      }
      if (headerValue === "Neaktívny") {
        return rowValue === 0;
      }
      return true;
      }

    const columnsChecklist = useMemo(() => [
        {
            title: 'ID',
            field: 'id',
            headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false,
            headerFilterFunc: idHeaderFilter,
            minWidth: TABULATOR_LIST_ID_MIN_WIDTH,
            widthGrow: 1,
            sorter: 'number',
            hozAlign: 'left',
        },
        { title: t('Common.Name'), field: 'name', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: diacriticInsensitiveFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Name')), widthGrow: 1 },
        { title: t('Common.Department'), field: 'custom_department', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: departmentFilter, minWidth: tabulatorColumnMinWidthFromTitle('Oddelenie'), widthGrow: 1, formatter: reactFormatter(<DepartmentFormatter />) },
        { title: t('Common.Users'), field: 'users', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: userFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Users')), widthGrow: 1, formatter: reactFormatter(<UserFormatter />) },
        { title: 'Odosielanie', field: 'sending_data', formatter: reactFormatter(<IntensityFormatter />), headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: intensityHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle('Odosielanie'), widthGrow: 1 },
        { title: t('Common.Notification'), field: 'cusom_notif_before', formatter: reactFormatter(<NotifBeforeFormatter />), headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: notifBeforeHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Notification')), widthGrow: 1 },
        { title: t('Common.Manager'), field: 'manager_name', formatter: reactFormatter(<ManagerFormatter />), headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: managerHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Manager')), widthGrow: 1 },
        { title: t('Common.ManagerDeadline'), field: 'manager_due_days', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: diacriticInsensitiveFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.ManagerDeadline')), widthGrow: 1 },
        { title: t('Common.Description'), field: 'description', headerFilter: embeddedEnterOnlyHeaderFilter,
            headerFilterLiveFilter: false, headerFilterFunc: diacriticInsensitiveFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Description')), widthGrow: 1 },
        {
            title: t('Common.ActivePlural'),
            field: 'is_active',
            formatter: reactFormatter(<ActiveFormatter />),
            headerFilter: 'select',
            headerFilterParams: { values: { '': t('Common.FilterAll'), '1': t('Common.Active'), '0': t('Common.Inactive') } },
            headerFilterFunc: (headerValue, rowValue) => {
                if (headerValue === '' || headerValue == null) return true;
                return String(Number(rowValue) === 1 ? 1 : 0) === String(headerValue);
            },
            minWidth: tabulatorColumnMinWidthFromTitle(t('Common.ActivePlural'), 'multiselect'),
            widthGrow: 1,
        },
        ...auditTailColumns,
    ], [auditTailColumns]);

    /** Maska stĺpcov podľa záložky zachytenej pri otvorení dialógu (mntn017: tri tabuľky). */
    const getMaskDialogContext = useCallback(() => {
        const t = maskDialogTabIndex;
        if (t === 0) {
            return {
                ref: refMaint,
                columnsVisible,
                setColumnsVisible,
                page: PAGE_MAINT,
                columnsArray: columns,
                defaultVisibility: DEFAULT_MAINTENANCE_CARD_DETAIL_COLUMN_VISIBILITY,
                mergeVisibilityFromSaved: mergeMaintColumnVisibilityFromSaved,
                applyVisibilityToTable: applyMaintDataColumnVisibility,
            };
        }
        if (t === 2) {
            return {
                ref: refTechnicians,
                columnsVisible: columnsVisibleTechnicians,
                setColumnsVisible: setColumnsVisibleTechnicians,
                page: PAGE_TECHNICIANS,
                columnsArray: columnsTechnicians,
                defaultVisibility: DEFAULT_MAINTENANCE_CARD_DETAIL_TECHNICIANS_COLUMN_VISIBILITY,
                mergeVisibilityFromSaved: mergeTechniciansColumnVisibilityFromSaved,
                applyVisibilityToTable: applyTechniciansDataColumnVisibility,
            };
        }
        return {
            ref: refChecklist,
            columnsVisible: columnsVisibleChecklist,
            setColumnsVisible: setColumnsVisibleChecklist,
            page: PAGE_CHECKLIST,
            columnsArray: columnsChecklist,
            defaultVisibility: DEFAULT_MAINTENANCE_CARD_DETAIL_CHECKLIST_COLUMN_VISIBILITY,
            mergeVisibilityFromSaved: mergeChecklistColumnVisibilityFromSaved,
            applyVisibilityToTable: applyChecklistDataColumnVisibility,
        };
    }, [maskDialogTabIndex, columnsVisible, columnsVisibleChecklist, columnsVisibleTechnicians, columns, columnsChecklist, columnsTechnicians]);

    const closeMenu = useCallback(() => {
        setTimeout(() => {
            OverflowMenuProvider.setVisible?.(null);
            setExpandedKeys({});
        }, 0);
    }, []);

    const hasApplicableStandardMaskActive = useMemo(
        () => hasApplicableStandardMaskRow(state.standard_mask_filters, active.page, active.mergeVisibilityFromSaved),
        [state.standard_mask_filters, active]
    );

    const openMaskDialog = useCallback(() => {
        setMaskDialogTabIndex(tabIndex);
        if (tabIndex === 0) {
            const merged = mergeMaintColumnVisibilityFromSaved(columnsVisible);
            setColumnsVisible(ensureMaskDialogState(DEFAULT_MAINTENANCE_CARD_DETAIL_COLUMN_VISIBILITY, merged));
        } else if (tabIndex === 2) {
            const merged = mergeTechniciansColumnVisibilityFromSaved(columnsVisibleTechnicians);
            setColumnsVisibleTechnicians(ensureMaskDialogState(DEFAULT_MAINTENANCE_CARD_DETAIL_TECHNICIANS_COLUMN_VISIBILITY, merged));
        } else {
            const merged = mergeChecklistColumnVisibilityFromSaved(columnsVisibleChecklist);
            setColumnsVisibleChecklist(ensureMaskDialogState(DEFAULT_MAINTENANCE_CARD_DETAIL_CHECKLIST_COLUMN_VISIBILITY, merged));
        }
        setMaskVisible(true);
        closeMenu();
    }, [tabIndex, columnsVisible, columnsVisibleChecklist, columnsVisibleTechnicians, closeMenu]);

    const confirmSaveStandardMaskActive = useCallback(
        createConfirmSaveStandardMask({
            maskPage: active.page,
            getTable: getActiveTable,
            setStandardMaskFilter,
            defaultColumnVisibility: active.defaultVisibility,
            toast,
        }),
        [active, getActiveTable, setStandardMaskFilter, toast]
    );

    const confirmApplyStandardLayoutActive = useCallback(
        createConfirmApplyStandardLayoutToUserMask({
            maskPage: active.page,
            state,
            setUserMaskFilter,
            defaultColumnVisibility: active.defaultVisibility,
            mergeVisibilityFromSaved: active.mergeVisibilityFromSaved,
            toast,
            closeMenu,
            onAppliedToTable: ({ colsForSave, attributes }) => {
                const table = getActiveTable();
                if (!table) return;
                const fieldOrder = tabIndex === 0
                    ? MAINTENANCE_CARD_DETAIL_DATA_FIELD_ORDER
                    : tabIndex === 2
                        ? MAINTENANCE_CARD_DETAIL_TECHNICIANS_DATA_FIELD_ORDER
                        : MAINTENANCE_CARD_DETAIL_CHECKLIST_DATA_FIELD_ORDER;
                active.isRestoringRef.current = true;
                applyCompanyListColumnLayout(table, attributes, fieldOrder);
                active.setColumnsVisible(colsForSave);
                active.applyVisibilityToTable(table, colsForSave);
                setTimeout(() => {
                    active.isRestoringRef.current = false;
                }, 0);
            },
        }),
        [active, state, closeMenu, getActiveTable, setUserMaskFilter, toast, tabIndex]
    );

    const saveMaskDialogColumns = useCallback(() => {
        const ctx = getMaskDialogContext();
        const normalized = normalizeColumnVisibilityForSave(ctx.defaultVisibility, ctx.columnsVisible);
        if (!Object.values(normalized).some(Boolean)) {
            toast?.current?.show({
                severity: 'warn',
                summary: 'Maska',
                detail: t('Common.SelectAtLeastOneColumn'),
                life: 4000,
            });
            return;
        }
        const table = resolveTabulatorInstance(ctx.ref);
        ctx.applyVisibilityToTable(table, normalized);
        const filtersSnapshot = table?.getHeaderFilters?.() ?? [];
        setUserMaskFilter(ctx.page, 'all', normalized, filtersSnapshot, null, null);
        ctx.setColumnsVisible(normalized);
        setMaskVisible(false);
    }, [getMaskDialogContext, setUserMaskFilter, toast]);

    const setMaskField = useCallback((field, value) => {
        const ctx = getMaskDialogContext();
        createMaskSetFieldHandler({
            defaultColumnVisibility: ctx.defaultVisibility,
            columnsVisible: ctx.columnsVisible,
            setColumnsVisible: ctx.setColumnsVisible,
            getTable: () => resolveTabulatorInstance(ctx.ref),
            applyVisibilityToTable: ctx.applyVisibilityToTable,
            toast,
        })(field, value);
    }, [getMaskDialogContext, toast]);

    const maskDialogSelectAll = useCallback(() => {
        const ctx = getMaskDialogContext();
        createMaskSelectAllHandler({
            defaultColumnVisibility: ctx.defaultVisibility,
            setColumnsVisible: ctx.setColumnsVisible,
            getTable: () => resolveTabulatorInstance(ctx.ref),
            applyVisibilityToTable: ctx.applyVisibilityToTable,
        })();
    }, [getMaskDialogContext]);

    const maskDialogDeselectAll = useCallback(() => {
        const ctx = getMaskDialogContext();
        createMaskDeselectAllHandler({
            defaultColumnVisibility: ctx.defaultVisibility,
            setColumnsVisible: ctx.setColumnsVisible,
            getTable: () => resolveTabulatorInstance(ctx.ref),
            applyVisibilityToTable: ctx.applyVisibilityToTable,
        })();
    }, [getMaskDialogContext]);

    const items = useMemo(() => [{
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: buildMaintenanceMaskAkcieSubItems({
            maskPage: active.page,
            getTable: getActiveTable,
            setUserMaskFilter,
            cleanSorters,
            captureHScroll: () => {},
            refreshFromStart: refreshActiveTable,
            closeMenu,
            openMaskDialog,
            openChosenNotificationPreferences,
            hasApplicableStandardMask: hasApplicableStandardMaskActive,
            confirmApplyStandardLayoutToUserMask: confirmApplyStandardLayoutActive,
            itemRenderer,
        }),
    }], [active.page, getActiveTable, closeMenu, openMaskDialog, hasApplicableStandardMaskActive, confirmApplyStandardLayoutActive, refreshActiveTable]);

    const maintRows = useMemo(() => {
        if (Array.isArray(formMachine?.machine_card)) {
            return formMachine.machine_card;
        }
        return (machineCards ?? []).find((c) => String(c.id) === String(formMachine?.id))?.machine_card || [];
    }, [machineCards, formMachine?.id, formMachine?.machine_card]);

    useEffect(() => {
        const prevId = prevMachineIdRef.current;
        const nextId = formMachine?.id;
        if (prevId === nextId) return;
        prevMachineIdRef.current = nextId;
        if (nextId == null) return;

        refMaintTabulator.current?.replaceData?.(maintRows);
        refChecklistTabulator.current?.replaceData?.(checklistTemplatesForMachine);
        if (tabIndex === 2) {
            loadFavoriteMaintenanceContacts();
        }
    }, [formMachine?.id, maintRows, checklistTemplatesForMachine, tabIndex, loadFavoriteMaintenanceContacts]);

    useEffect(() => {
        if (tabIndex !== 2 || !refTechniciansTabulator.current) return;
        refTechniciansTabulator.current.replaceData?.(favoriteTechniciansTableData);
    }, [tabIndex, favoriteTechniciansTableData]);

    function getSelectedMaintenanceType(typeId, fallbackObj, maintenanceTypes, allTypes) {
        const id = Number(typeId);
        if (!id) return null;

        // pri update často máš už priamo objekt v selectedCard.maintenance_type
        if (fallbackObj?.id === id) return fallbackObj;

        return (
            maintenanceTypes?.find((m) => Number(m.id) === id) ||
            allTypes?.find((m) => Number(m.id) === id) ||
            null
        );
    }

    function getResponsibleEmployeeIdFromMaintenanceType(mt) {
        if (!mt || !mt.use_central_responsible_person) return "";
        if (mt.responsible_employee_id != null) return mt.responsible_employee_id;
        if (mt.responsible?.id != null) return mt.responsible.id;
        return "";
    }

    /** Text option pre select úkonu: Názov úkonu — norma — interval (ako mntn014) */
    function maintenanceTypeOptionLabel(mt) {
        if (!mt) return '';
        const n = mt.name ?? '';
        const norm = mt.norm ? ` — ${mt.norm}` : '';
        const interval = mt.interval_months != null ? ` — ${mt.interval_months}mes.` : '';
        return `${n}${norm}${interval}`.trim();
    }

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <IntersectionObserverWrapper>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={tabIndex === 2 ? !user.permissions?.includes('edit maintenance') : insertCopyIcon} onClick={() => { if (tabIndex === 2) { setFavoritePickerIds(favoriteContactsFromApi.map((c) => c.id)); resetFavoriteWizard(); setVisibleFavoritePicker(true); } else addNewMachineCard(); }} title={tabIndex === 2 ? t('Maintenance.AddServiceTechnician') : ''}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={tabIndex === 2 ? editTechnicianIcon : editIcon} onClick={() => { if (tabIndex === 2) { const sel = refTechnicians.current?.getSelectedData?.() ?? []; if (sel.length === 1) openFavoriteTechnicianEdit(sel[0]); } else editNewMachineCard(); }} title={tabIndex === 2 ? t('Maintenance.EditServiceTechnician') : ''}><EditIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" disabled={tabIndex === 2 ? deleteTechnicianIcon : deleteIcon} onClick={() => { if (tabIndex === 2) confirmRemoveFromFavorites(); else confirm(); }} title={tabIndex === 2 ? t('Common.RemoveFromFavorites') : ''}><DeleteIcon/></button></div>
          {tabIndex === 0 && <><div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="activate"><button className="disabled:opacity-25" disabled={activateIcon} onClick={confirmActivate}><ActivateIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="deactivate"><button className="disabled:opacity-25" disabled={deactivateIcon} onClick={() => setVisibleDeactivate(true)}><DeactivateIcon/></button></div></>}
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="print"><button onClick={() => active?.ref?.current?.print(false, true)} title={t('Common.PrintTab', { tab: toolbarTabLabel })}><PrintIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button onClick={() => { if (tabIndex === 0) { refetchMachineCards(); if (formMachine?.id) getRequest(`/api/machine_cards/by_machine/${formMachine.id}`).then((r) => { if (r?.data) setFormMachine(r.data); }); } else if (tabIndex === 2) { refreshTechnicians(); } else { refChecklist.current?.replaceData?.(checklistTemplatesForMachine); refChecklist.current?.redraw?.(true); } }} title={t('Common.RefreshTab', { tab: toolbarTabLabel })}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button type="button" onClick={() => openFavoriteDialog(t('Maintenance.EditMachineCard'), active.page)}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button type="button" onClick={() => setFastView(active.page, active.columnsVisible, tabIndex === 0 ? columns : tabIndex === 2 ? columnsTechnicians : columnsChecklist)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          {canSetStandardMask ? (
            <div className="flex w-10 h-10 px-2 py-1 justify-center" data-targetid="save-standard-mask">
              <button type="button" title={t('Common.SaveStandardMask')} aria-label={t('Common.SaveStandardMask')} onClick={confirmSaveStandardMaskActive} className="flex items-center justify-center">
                <i className="pi pi-bookmark text-white text-xl" aria-hidden="true" />
              </button>
            </div>
          ) : null}
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
    <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto " minSize={20} size={25}>
        <form onSubmit={formik.handleSubmit} className='w-full'>
        <div className="relative flex flex-col overflow-x">
          <div className='xl:grid grid-cols-2 gap-1 mb-2'>
          <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">
                   KARTA STROJA
                </h1>
                <label className="block text-md font-semibold text-gray-800">Por.č.: {formMachine?.id}</label>
                <div className="mt-6">
                    <div className="md:grid grid-cols-2 gap-2 mb-2">
                        <div>
                            <label
                                htmlFor="name"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.MachineName')}</label>
                            <input
                                name='name'
                                type="text"
                                readOnly value={formMachine?.name}
                                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="machine_type_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('MachineList.Column.MachineTypeName')}</label>
                            <select
                                name='machine_type_id' disabled
                                value={formMachine?.machine_type_id}
                                className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                                <option value="">{t('MachineAdd.SelectMachineType')}</option>
                                {state.machine_types.map((machine_type) => (
                                <option key={machine_type.id} value={machine_type.id}>{machine_type.name}</option>
                            ))}
                            </select>
                        </div>
                        <div>
                            <label
                                htmlFor="type"
                                className="block text-md font-semibold text-gray-800"
                            >
                                Typ stroja
                            </label>
                            <input
                                name='type' readOnly
                                type="text"
                                value={formMachine?.type}
                                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="serial_number"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.SerialNumber')}</label>
                            <input
                                name='serial_number' readOnly
                                type="text"
                                value={formMachine?.serial_number}
                                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                    </div>
                </div>  
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <div className="md:grid grid-cols-2 gap-2 mb-2">
                    
                    <div>
                        <label
                            htmlFor="fabrication_year"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.FabricationYear')}</label>
                        <input
                            name='fabrication_year' readOnly
                            type="number"
                            value={formMachine?.fabrication_year}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                    </div>
                    <div>
                        <label
                            htmlFor="last_overhaul"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.LastOverhaul')}</label>
                        <input 
                            name='last_overhaul' readOnly
                            type="date"
                            value={formMachine?.last_overhaul}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                    </div>
                    <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.MachineDescription')}</label>
                        <textarea
                            name='description' readOnly
                            value={formMachine?.description}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                    </div> 
                    <div>
                    <label
                        htmlFor="manufacturer"
                        className="block text-md font-semibold text-gray-800 mt-2"
                    >{t('Common.Manufacturer')}</label>
                    <input
                        name='manufacturer' readOnly
                        type="text"
                        value={formMachine?.manufacturer}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                </div>
                </div>
            </div>
            </div> 
            </div>
             </form>
    </SplitterPanel>
    <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full overflow-y-auto" size={40} style={{minHeight: '110px'}}> 
        <div className="m-2 bg-white border border-gray-300 rounded-md shadow-sm overflow-hidden h-full">
        <TabView className="maintenance-card-detail-tabview h-full" activeIndex={tabIndex} onTabChange={(e) => setTabIndex(e.index)}>
            <TabPanel header={t('Maintenance.Tab.Tasks')}>
               <ReactTabulator
                data={maintRows}
                onRef={(r) => {
                    ref.current = r.current;
                    refMaint.current = r.current;
                    refMaintTabulator.current = r.current?.table ?? r.current;
                }}
                className='h-full w-full' //176px h-[calc(100vh_-_176px)]
                columns={columns}
                events={{
                    rowSelectionChanged: onSelectRow,
                    tableBuilt: () => {
                        const table = refMaintTabulator.current;
                        if ((loadingMachineCards || loadingTypes) && table?.initialized) table.alert?.(t('Common.LoadingData'));
                        restoreEmbeddedMaskToTable(table, PAGE_MAINT, mergeMaintColumnVisibilityFromSaved, applyMaintDataColumnVisibility, setColumnsVisible, isRestoringMaintRef, MAINTENANCE_CARD_DETAIL_DATA_FIELD_ORDER);
                    },
                    ...getTabulatorPersistLayoutEvents(PAGE_MAINT, refMaintTabulator, setUserMaskFilter),
                }}
                options={{renderHorizontal:"virtual",layout:"fitColumns",movableColumns:true,rowHeight:42,
                filterMode: 'local',
                dataLoader: false,
                dataLoaderLoading: t('Common.LoadingData'),
                dataLoaderError: t('Common.LoadFailed'),
                printAsHtml:true,printRowRange:"active",
                printHeader: function () {
            const bodyHtml = ReactDOMServer.renderToStaticMarkup(
                        <div className="w-full text-[11px]">
{/* 2. riadok – polia v dvoch stĺpcoch */}
                            <div className="grid grid-cols-2 gap-4 mb-2">
                                {/* Ľavý stĺpec */}
                                <div className="space-y-2">
                                    <div>
                                        <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Ui.R67.Por_c')}</label>
                                        <input
                                            type="text"
                                            readOnly
                                            value={formMachine?.id ?? ''}
                                            className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.MachineName')}</label>
                                        <input
                                            name="name"
                                            type="text"
                                            readOnly
                                            value={formMachine?.name || ''}
                                            className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                        />
                                    </div>
                                    <div className="grid grid-cols-2 gap-2">
                                        <div>
                                            <label className="block text-[11px] text-left font-semibold text-gray-800">{t('MachineList.Column.MachineTypeName')}</label>
                                            <input
                                                name="machine_type_name"
                                                type="text"
                                                readOnly
                                                value={formMachine?.machine_type?.name || ''}
                                                className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-[11px] text-left font-semibold text-gray-800">
                                                Typ stroja
                                            </label>
                                            <input
                                                name="type"
                                                type="text"
                                                readOnly
                                                value={formMachine?.type || ''}
                                                className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Pravý stĺpec */}
                                <div className="space-y-2">
                                    <div>
                                        <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.SerialNumber')}</label>
                                        <input
                                            name="serial_number"
                                            type="text"
                                            readOnly
                                            value={formMachine?.serial_number || ''}
                                            className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                        />
                                    </div>

                                    <div className="grid grid-cols-2 gap-2">
                                        <div>
                                            <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.FabricationYear')}</label>
                                            <input
                                                name="fabrication_year"
                                                type="number"
                                                readOnly
                                                value={formMachine?.fabrication_year || ''}
                                                className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.LastOverhaul')}</label>
                                            <input
                                                name="last_overhaul"
                                                type="date"
                                                readOnly
                                                value={formMachine?.last_overhaul || ''}
                                                className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.Manufacturer')}</label>
                                        <input
                                            name="manufacturer"
                                            type="text"
                                            readOnly
                                            value={formMachine?.manufacturer || ''}
                                            className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* 3. riadok – popis cez celú šírku */}
                            <div className="mt-1">
                                <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.MachineDescription')}</label>
                                <textarea
                                    name="description"
                                    readOnly
                                    value={formMachine?.description || ''}
                                    className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md min-h-[40px]"
                                />
                            </div>
                        </div>
                    );
            return buildCanonicalPrintHeaderHtml({
                branding: state?.branding,
                productFallbackSrc: defaultProductLogoSrc,
                companySettingsPrint: state?.company_settings_print,
                moduleSettings: state?.module_settings,
                title: t('Print.Title.MaintenanceCardDetail'),
                printDateLabel: t('Print.DateLabel'),
                bodyHtml,
            });
        },
                printFooter: function () {
                    return buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print });
                }
                }}/>
            </TabPanel>
            <TabPanel header={t('Maintenance.Tab.Checklists')}>
                <ReactTabulator
                    data={checklistTemplatesForMachine}
                    onRef={(r) => {
                        refChecklist.current = r.current;
                        refChecklistTabulator.current = r.current?.table ?? r.current;
                    }}
                    className="h-full w-full"
                    columns={columnsChecklist}
                    events={{
                        tableBuilt: () => restoreEmbeddedMaskToTable(refChecklistTabulator.current, PAGE_CHECKLIST, mergeChecklistColumnVisibilityFromSaved, applyChecklistDataColumnVisibility, setColumnsVisibleChecklist, isRestoringChecklistRef, MAINTENANCE_CARD_DETAIL_CHECKLIST_DATA_FIELD_ORDER),
                        ...getTabulatorPersistLayoutEvents(PAGE_CHECKLIST, refChecklistTabulator, setUserMaskFilter),
                    }}
                    options={{
                    renderHorizontal:"virtual",
                    layout:"fitColumns",
                    movableColumns:true,
                    rowHeight:42,
                    filterMode: 'local',
                    dataLoader: false,
                    printAsHtml:true,
                    printRowRange:"active",
                    height: "100%",
                    }}
                />
            </TabPanel>
            <TabPanel header={t('Maintenance.Tab.Technicians')}>
                <ReactTabulator
                    data={favoriteTechniciansTableData}
                    onRef={(r) => {
                        refTechnicians.current = r?.current;
                        refTechniciansTabulator.current = r.current?.table ?? r.current;
                    }}
                    className="h-full w-full"
                    columns={columnsTechnicians}
                    events={{
                        rowSelectionChanged: onSelectRowTechnicians,
                        tableBuilt: () => restoreEmbeddedMaskToTable(refTechniciansTabulator.current, PAGE_TECHNICIANS, mergeTechniciansColumnVisibilityFromSaved, applyTechniciansDataColumnVisibility, setColumnsVisibleTechnicians, isRestoringTechniciansRef, MAINTENANCE_CARD_DETAIL_TECHNICIANS_DATA_FIELD_ORDER),
                        ...getTabulatorPersistLayoutEvents(PAGE_TECHNICIANS, refTechniciansTabulator, setUserMaskFilter),
                    }}
                    options={{
                        renderHorizontal: 'virtual',
                        layout: 'fitColumns',
                        movableColumns: true,
                        rowHeight: 42,
                        filterMode: 'local',
                        dataLoader: false,
                        height: '100%',
                    }}
                />
            </TabPanel>
        </TabView>
        </div>
    </SplitterPanel>
    </Splitter> 
    <Dialog header={t('Maintenance.EditInMachineCard')} visible={visibleCard} style={{ width: '40vw' }} onHide={() => hideEditCard()}>
    <form onSubmit={formikUpdate.handleSubmit}>
                        <div>
                            <label
                                htmlFor="machineType"
                                className="block text-md font-semibold text-gray-800"
                            >{t('MachineList.Column.MachineTypeName')}</label>
                            <select 
                            name='machineType'
                            onChange={(e) => filterMaintenanceTypes(e.target.value)} value={machineType}
                            className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                            <option value="">{t('MachineAdd.SelectMachineType')}</option>
                            {state.machine_types.map((machine_type) => (
                                <option key={machine_type.id} value={machine_type.id}>{machine_type.name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label
                                htmlFor="maintenance_type_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.TaskName')}</label>
                            <select required
                            name='maintenance_type_id'
                            onChange={(e) => {
                                const newId = e.target.value;
                                formikUpdate.setFieldValue("maintenance_type_id", newId);
                                const mt = getSelectedMaintenanceType(newId,null,maintenanceTypes,allMaintenanceTypes);
                                const respId = getResponsibleEmployeeIdFromMaintenanceType(mt);
                                formikUpdate.setFieldValue("responsible_employee_id", respId || "");
                                if (mt?.use_central_required_attachment) formikUpdate.setFieldValue("required_attachment", 1);
                                if (mt?.use_central_service_person) {
                                    formikUpdate.setFieldValue("company_id", mt?.central_company_id ?? mt?.centralCompany?.id ?? "");
                                    formikUpdate.setFieldValue("company_contact_id", mt?.central_company_contact_id ?? mt?.centralCompanyContact?.id ?? "");
                                    formikUpdate.setFieldValue("lecturer_id", mt?.central_lecturer_id != null ? String(mt.central_lecturer_id) : (mt?.centralCompanyContact?.employee_id != null || mt?.central_company_contact?.employee_id != null ? "1" : ""));
                                }
                            }}
                            value={formikUpdate.values?.maintenance_type_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_ukon')}</option>
                            {maintenanceTypes.map((mt) => (
                                <option key={mt.id} value={mt.id}>{maintenanceTypeOptionLabel(mt)}</option>
                            ))}
                            </select>
                        </div>
                        <div>
                            <label
                                htmlFor="initial_date"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Ui.R67.Datum_prvotneho_vykonania')}</label>
                            <input
                                name='initial_date'
                                type="date"
                                required
                                onChange={formikUpdate.handleChange} value={formikUpdate.values?.initial_date}
                                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="deactivation_date"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Ui.R67.Datum_deaktivacie')}</label>
                            <input
                                name='deactivation_date'
                                type="date"
                                onChange={formikUpdate.handleChange} value={formikUpdate.values?.deactivation_date}
                                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Description')}</label>
                        <input
                            name='description'
                            type="text"
                            onChange={formikUpdate.handleChange} value={formikUpdate.values?.description}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                            <label
                                htmlFor="machine_part"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.MachinePart')}</label>
                            <input
                                name='machine_part'
                                type="text"
                                onChange={formikUpdate.handleChange} value={formikUpdate.values?.machine_part}
                                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                            {formikUpdate?.errors?.machine_part && (
                                <div className="mt-1 text-sm text-red-600">
                                {formikUpdate.errors.machine_part}
                                </div>
                            )}
                        </div>
                        <div className="mt-3">
                            <label className="block text-md font-semibold text-gray-800">{t('Common.ResponsiblePerson')}</label>
                            {selectedCard?.maintenance_type?.use_central_responsible_person ? (
                                <>
                                    <p className="mt-1 text-sm text-gray-600">{t('Ui.R67.Je_nastavena_centralna_zodpovedna_osoba')}</p>
                                    <Dropdown
                                        name="responsible_employee_id"
                                        value={selectedCard?.maintenance_type?.responsible_employee_id ?? selectedCard?.maintenance_type?.responsible?.id ?? null}
                                        options={(state.employees || []).map(emp => ({ label: emp.name, value: emp.id }))}
                                        placeholder={t('Common.SelectEmployee')}
                                        className="w-full mt-2"
                                        panelClassName="max-w-full"
                                        disabled
                                    />
                                </>
                            ) : (
                                <Dropdown
                                    name="responsible_employee_id" value={formikUpdate.values.responsible_employee_id || null}
                                    onChange={(e) => formikUpdate.setFieldValue("responsible_employee_id", e.value)}
                                    options={(state.employees || []).map(emp => ({ label: emp.name, value: emp.id }))}
                                    placeholder={t('Common.SelectEmployee')}
                                    filter showClear
                                    className="w-full mt-2" panelClassName="max-w-full"
                                />
                            )}
                        </div>
                        {(() => {
                            const mtUpdate = getSelectedMaintenanceType(formikUpdate.values?.maintenance_type_id, null, maintenanceTypes, allMaintenanceTypes);
                            if (mtUpdate?.use_central_required_attachment) {
                                return (
                                    <div className="mt-3 px-3 py-2 bg-gray-200 rounded border border-gray-400 text-gray-700 text-sm">
                                        Povinná príloha (Centrálne zadaná povinná príloha)
                                    </div>
                                );
                            }
                            return (
                                <div className="mt-3 flex items-center">
                                    <Checkbox
                                        inputId="required_attachment_update"
                                        checked={Number(formikUpdate.values.required_attachment) === 1}
                                        onChange={(e) => formikUpdate.setFieldValue("required_attachment", e.checked ? 1 : 0)}
                                        className="mr-2"
                                    />
                                    <label htmlFor="required_attachment_update" className="font-normal text-md text-gray-800">{t('Common.MandatoryAttachment')}</label>
                                </div>
                            );
                        })()}
                        <div>
                        <label
                            htmlFor="protocol"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Predloha
                        </label>
                        {selectedCard?.maintenance_type?.use_unified_template ? (
                        <p className="mt-2 px-3 py-2 bg-gray-200 rounded border border-gray-400 text-gray-700 text-sm">{t('Ui.R67.Je_nastavena_centralna_jednotna_predloha')}</p>
                        ) : (
                        <input
                            name='files'
                            ref={updateFileListRef}
                            onChange={handleUpdateFileChange}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                            type='file'
                            multiple="multiple"
                            id='file'/>
                        )}
                        </div>
                        {images!=='' && images.map((img) => ( <div className='flex flex-row p-2' key={img.id}>
                            <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>
                                <embed src={img.url+'#view=FitH&scrollbar=0'} width='100px' height='65px'></embed>
                            </div>
                                <div className='flex flex-col ml-4'>
                                <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}{img.is_central ? t('Maintenance.CentralTemplateSuffix') : ''}</a>
                                {!img.is_central && !getSelectedMaintenanceType(formikUpdate.values?.maintenance_type_id, null, maintenanceTypes, allMaintenanceTypes)?.use_unified_template && (
                                <button type="button" className='w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900' onClick={() => deleteFiles(img)} ><DeleteIcon/><span className='text-white ml-1'>{t('Common.Clear')}</span></button>
                                )}
                                </div>
                            </div>))}
                        {(() => {
                            const mtFromList = getSelectedMaintenanceType(formikUpdate.values?.maintenance_type_id, null, maintenanceTypes, allMaintenanceTypes);
                            const mtUpdate = selectedCard?.maintenance_type || mtFromList;
                            const useCentralUpdate = mtUpdate?.use_central_service_person && (mtUpdate?.central_company_id || mtUpdate?.central_company_contact_id);
                            if (useCentralUpdate) {
                                const centralCompanyId = mtUpdate?.central_company_id ?? mtUpdate?.centralCompany?.id;
                                const centralLecturerId = mtUpdate?.central_lecturer_id != null ? mtUpdate.central_lecturer_id : (mtUpdate?.centralCompanyContact?.employee_id != null || mtUpdate?.central_company_contact?.employee_id != null ? 1 : 0);
                                const centralContactId = mtUpdate?.central_company_contact_id ?? mtUpdate?.centralCompanyContact?.id;
                                const centralContactName = mtUpdate?.centralCompanyContact?.employee?.name || mtUpdate?.centralCompanyContact?.name || mtUpdate?.central_company_contact?.employee?.name || mtUpdate?.central_company_contact?.name || '—';
                                return (
                                    <>
                                        <p className="mt-2 text-sm text-gray-600">{t('Ui.R67.Je_nastavena_centralna_servisna_firma_a_servisny_technik')}</p>
                                        <div>
                                            <label htmlFor="company_id_central_update" className="block text-md font-semibold text-gray-800 mt-2">{t('Common.ServiceCompany')}</label>
                                            <select id="company_id_central_update" disabled value={centralCompanyId ?? ''} className="block w-full px-4 py-2 mt-2 text-gray-600 bg-gray-100 border rounded-md">
                                                <option value="">{t('Ui.R67.Vyber_serv_firmu_2')}</option>
                                                {(state.maintenance_companies || []).map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <label htmlFor="lecturer_id_central_update" className="block text-md font-semibold text-gray-800 mt-2">Druh technika</label>
                                            <select id="lecturer_id_central_update" disabled value={centralLecturerId} className="block w-full px-4 py-2 mt-2 text-gray-600 bg-gray-100 border rounded-md">
                                                <option value="">{t('Ui.R67.Vyber_druh_technika')}</option>
                                                {lecturers.map((l) => (
                                                    <option key={l.id} value={l.id}>{l.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <label htmlFor="company_contact_id_central_update" className="block text-md font-semibold text-gray-800 mt-2">{t('Common.ServiceTechnician')}</label>
                                            <select id="company_contact_id_central_update" disabled value={centralContactId ?? ''} className="block w-full px-4 py-2 mt-2 text-gray-600 bg-gray-100 border rounded-md">
                                                <option value="">{t('Ui.R67.Vyber_servisneho_technika')}</option>
                                                {centralContactId ? <option value={centralContactId}>{centralContactName}</option> : null}
                                            </select>
                                        </div>
                                    </>
                                );
                            }
                            return (
                                <>
                        <div>
                            <label
                                htmlFor="company_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.ServiceCompany')}</label>
                            <select
                            name='company_id'
                            onChange={(e) => changeCompany(e.target.value)} value={formikUpdate.values?.company_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_serv_firmu_2')}</option>
                            {state.maintenance_companies.map((maintenance_company) => (
                                <option key={maintenance_company.id} value={maintenance_company.id}>{maintenance_company.name}</option>
                            ))}
                            </select>
                        </div> 
                        {(formikUpdate.values?.company_id!="" && formikUpdate.values?.company_id!=null)  && <><div>
                            <label
                                htmlFor="lecturer_id"
                                className="block text-md font-semibold text-gray-800"
                            >
                            Druh technika
                            </label>
                            <select
                            name='lecturer_id'
                            onChange={(e) => changeLecturer(e.target.value)} value={formikUpdate.values?.lecturer_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_druh_technika')}</option>
                            {lecturers.map((lecturer) => (
                                <option key={lecturer.id} value={lecturer.id}>{lecturer.name}</option>
                            ))}
                            </select>
                        </div>
                        {(formikUpdate.values?.lecturer_id === 0 || formikUpdate.values?.lecturer_id === 1 || formikUpdate.values?.lecturer_id === "0" || formikUpdate.values?.lecturer_id === "1") && <div>
                            <label
                                htmlFor="company_contact_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.ServiceTechnician')}</label>
                            <select
                            name='company_contact_id'
                            onChange={formikUpdate.handleChange} value={formikUpdate.values?.company_contact_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_servisneho_technika')}</option>
                            {companyContacts.map((contact) => (
                                <option key={contact.id} value={contact.id}>{contact?.employee?.name || contact?.name}</option>
                            ))}
                            </select>
                        </div>}</>}
                                </>
                            );
                        })()}
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
            </form>
      </Dialog>
        <Dialog header={t('Maintenance.AddToMachineTasksCard')} visible={showMachineCardAdd} style={{ width: '40vw' }} onHide={() => setShowMachineCardAdd(false)}>
        <form onSubmit={formik.handleSubmit}>
                        <div>
                            <label
                                htmlFor="machineType"
                                className="block text-md font-semibold text-gray-800"
                            >{t('MachineList.Column.MachineTypeName')}</label>
                            <select 
                            name='machineType'
                            onChange={(e) => filterMaintenanceTypes(e.target.value)} value={machineType}
                            className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                            <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                            {state.machine_types.map((machine_type) => (
                                <option key={machine_type.id} value={machine_type.id}>{machine_type.name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label
                                htmlFor="maintenance_type_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.TaskName')}</label>
                            <select required
                            name='maintenance_type_id'
                            onChange={(e) => {
                                const newId = e.target.value;
                                formik.setFieldValue("maintenance_type_id", newId);
                                const mt = getSelectedMaintenanceType(newId,null,maintenanceTypes,allMaintenanceTypes);
                                const respId = getResponsibleEmployeeIdFromMaintenanceType(mt);
                                formik.setFieldValue("responsible_employee_id", respId || "");
                                if (mt?.use_central_required_attachment) formik.setFieldValue("required_attachment", 1);
                                if (mt?.use_central_service_person) {
                                    formik.setFieldValue("company_id", mt?.central_company_id ?? mt?.centralCompany?.id ?? "");
                                    formik.setFieldValue("company_contact_id", mt?.central_company_contact_id ?? mt?.centralCompanyContact?.id ?? "");
                                    formik.setFieldValue("lecturer_id", mt?.central_lecturer_id != null ? String(mt.central_lecturer_id) : (mt?.centralCompanyContact?.employee_id != null || mt?.central_company_contact?.employee_id != null ? "1" : ""));
                                }
                            }}
                            value={formik.values.maintenance_type_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_ukon')}</option>
                            {maintenanceTypes.map((mt) => (
                                <option key={mt.id} value={mt.id}>{maintenanceTypeOptionLabel(mt)}</option>
                            ))}
                            </select>
                        </div>
                        <div>
                            <label
                                htmlFor="initial_date"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Ui.R67.Datum_prvotneho_vykonania')}</label>
                            <input
                                name='initial_date'
                                type="date"
                                required
                                onChange={formik.handleChange} value={formik.values.initial_date}
                                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Description')}</label>
                        <input
                            name='description'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.description}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                            <label
                                htmlFor="machine_part"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.MachinePart')}</label>
                            <input
                                name='machine_part'
                                type="text"
                                onChange={formik.handleChange} value={formik.values?.machine_part}
                                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                            {formik?.errors?.machine_part && (
                                <div className="mt-1 text-sm text-red-600">
                                {formik.errors.machine_part}
                                </div>
                            )}
                        </div>
                        <div className="mt-3">
                            <label className="block text-md font-semibold text-gray-800">{t('Common.ResponsiblePerson')}</label>
                            {(function() {
                                const mt = getSelectedMaintenanceType(formik.values.maintenance_type_id, null, maintenanceTypes, allMaintenanceTypes);
                                if (mt?.use_central_responsible_person) {
                                    const centralRespId = mt?.responsible_employee_id ?? mt?.responsible?.id ?? null;
                                    return (
                                        <>
                                            <p className="mt-1 text-sm text-gray-600">{t('Ui.R67.Je_nastavena_centralna_zodpovedna_osoba')}</p>
                                            <Dropdown
                                                name="responsible_employee_id"
                                                value={centralRespId}
                                                options={(state.employees || []).map(emp => ({ label: emp.name, value: emp.id }))}
                                                placeholder={t('Common.SelectEmployee')}
                                                className="w-full mt-2"
                                                panelClassName="max-w-full"
                                                disabled
                                            />
                                        </>
                                    );
                                }
                                return (
                                    <Dropdown
                                        name="responsible_employee_id" value={formik.values.responsible_employee_id || null}
                                        onChange={(e) => formik.setFieldValue("responsible_employee_id", e.value)}
                                        options={(state.employees || []).map(emp => ({ label: emp.name, value: emp.id }))}
                                        placeholder={t('Common.SelectEmployee')}
                                        filter showClear
                                        className="w-full mt-2" panelClassName="max-w-full"
                                    />
                                );
                            })()}
                        </div>
                        {(() => {
                            const mtAdd = getSelectedMaintenanceType(formik.values.maintenance_type_id, null, maintenanceTypes, allMaintenanceTypes);
                            if (mtAdd?.use_central_required_attachment) {
                                return (
                                    <div className="mt-3 px-3 py-2 bg-gray-200 rounded border border-gray-400 text-gray-700 text-sm">
                                        Povinná príloha (Centrálne zadaná povinná príloha)
                                    </div>
                                );
                            }
                            return (
                                <div className="mt-3 flex items-center">
                                    <Checkbox
                                        inputId="required_attachment_add"
                                        checked={Number(formik.values.required_attachment) === 1}
                                        onChange={(e) => formik.setFieldValue("required_attachment", e.checked ? 1 : 0)}
                                        className="mr-2"
                                    />
                                    <label htmlFor="required_attachment_add" className="font-normal text-md text-gray-800">{t('Common.MandatoryAttachment')}</label>
                                </div>
                            );
                        })()}
                        <div>
                        <label
                            htmlFor="protocol"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Predloha
                        </label>
                        {(() => {
                            const mtAddPredloha = getSelectedMaintenanceType(formik.values.maintenance_type_id, null, maintenanceTypes, allMaintenanceTypes);
                            if (mtAddPredloha?.use_unified_template) {
                                return (
                                    <p className="mt-2 px-3 py-2 bg-gray-200 rounded border border-gray-400 text-gray-700 text-sm">{t('Ui.R67.Je_nastavena_centralna_jednotna_predloha')}</p>
                                );
                            }
                            return (
                                <input
                                    name='files'
                                    ref={fileListRef}
                                    onChange={handleFileChange}
                                    className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                                    type='file'
                                    multiple="multiple"
                                    id='file'/>
                            );
                        })()}
                        </div>
                        {images!=='' && images.map((img) => ( <div className='flex flex-row p-2' key={img.id}>
                            <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>
                                <embed src={img.url+'#view=FitH&scrollbar=0'} width='100px' height='65px'></embed>
                            </div>
                                <div className='flex flex-col ml-4'>
                                <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}{img.is_central ? t('Maintenance.CentralTemplateSuffix') : ''}</a>
                                {!img.is_central && !getSelectedMaintenanceType(formik.values.maintenance_type_id, null, maintenanceTypes, allMaintenanceTypes)?.use_unified_template && (
                                <button type="button" className='w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900' onClick={() => deleteFiles(img)} ><DeleteIcon/><span className='text-white ml-1'>{t('Common.Clear')}</span></button>
                                )}
                                </div>
                            </div>))}
{(() => {
                            const mtAdd = getSelectedMaintenanceType(formik.values.maintenance_type_id, null, maintenanceTypes, allMaintenanceTypes);
                            const useCentralAdd = mtAdd?.use_central_service_person && (mtAdd?.central_company_id || mtAdd?.central_company_contact_id);
                            if (useCentralAdd) {
                                const centralCompanyId = mtAdd?.central_company_id ?? mtAdd?.centralCompany?.id;
                                const centralLecturerId = mtAdd?.central_lecturer_id != null ? mtAdd.central_lecturer_id : (mtAdd?.centralCompanyContact?.employee_id != null || mtAdd?.central_company_contact?.employee_id != null ? 1 : 0);
                                const centralContactId = mtAdd?.central_company_contact_id ?? mtAdd?.centralCompanyContact?.id;
                                const centralContactName = mtAdd?.centralCompanyContact?.employee?.name || mtAdd?.centralCompanyContact?.name || mtAdd?.central_company_contact?.employee?.name || mtAdd?.central_company_contact?.name || '—';
                                return (
                                    <>
                                        <p className="mt-2 text-sm text-gray-600">{t('Ui.R67.Je_nastavena_centralna_servisna_firma_a_servisny_technik')}</p>
                                        <div>
                                            <label htmlFor="company_id_central_add" className="block text-md font-semibold text-gray-800 mt-2">{t('Common.ServiceCompany')}</label>
                                            <select id="company_id_central_add" disabled value={centralCompanyId ?? ''} className="block w-full px-4 py-2 mt-2 text-gray-600 bg-gray-100 border rounded-md">
                                                <option value="">{t('Ui.R67.Vyber_serv_firmu_2')}</option>
                                                {(state.maintenance_companies || []).map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <label htmlFor="lecturer_id_central_add" className="block text-md font-semibold text-gray-800 mt-2">Druh technika</label>
                                            <select id="lecturer_id_central_add" disabled value={centralLecturerId} className="block w-full px-4 py-2 mt-2 text-gray-600 bg-gray-100 border rounded-md">
                                                <option value="">{t('Ui.R67.Vyber_druh_technika')}</option>
                                                {lecturers.map((l) => (
                                                    <option key={l.id} value={l.id}>{l.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <label htmlFor="company_contact_id_central_add" className="block text-md font-semibold text-gray-800 mt-2">{t('Common.ServiceTechnician')}</label>
                                            <select id="company_contact_id_central_add" disabled value={centralContactId ?? ''} className="block w-full px-4 py-2 mt-2 text-gray-600 bg-gray-100 border rounded-md">
                                                <option value="">{t('Ui.R67.Vyber_servisneho_technika')}</option>
                                                {centralContactId ? <option value={centralContactId}>{centralContactName}</option> : null}
                                            </select>
                                        </div>
                                    </>
                                );
                            }
                            return (
                                <>
                        <div>
                        <label
                            htmlFor="company_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.ServiceCompany')}</label>
                        <select
                        name='company_id'
                        onChange={(e) => changeCompany(e.target.value)} value={formik.values?.company_id}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="">{t('Ui.R67.Vyber_serv_firmu_2')}</option>
                        {state.maintenance_companies.map((maintenance_company) => (
                            <option key={maintenance_company.id} value={maintenance_company.id}>{maintenance_company.name}</option>
                        ))}
                        </select>
                    </div>
                    {(formik.values?.company_id!="" && formik.values?.company_id!=null)  && <><div>
                        <label
                            htmlFor="lecturer_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                        Druh technika
                        </label>
                        <select
                        name='lecturer_id'
                        onChange={(e) => changeLecturer(e.target.value)} value={formik.values?.lecturer_id}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="">{t('Ui.R67.Vyber_druh_technika')}</option>
                        {lecturers.map((lecturer) => (
                            <option key={lecturer.id} value={lecturer.id}>{lecturer.name}</option>
                        ))}
                        </select>
                    </div>
                    {(formik.values?.lecturer_id === 0 || formik.values?.lecturer_id === 1 || formik.values?.lecturer_id === "0" || formik.values?.lecturer_id === "1") && <div>
                        <label
                            htmlFor="company_contact_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.ServiceTechnician')}</label>
                        <select
                        name='company_contact_id'
                        onChange={formik.handleChange} value={formik.values?.company_contact_id}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="">{t('Ui.R67.Vyber_servisneho_technika')}</option>
                        {companyContacts.map((contact) => (
                            <option key={contact.id} value={contact.id}>{contact?.employee?.name || contact?.name}</option>
                        ))}
                        </select>
                    </div>}</>}
                                </>
                            );
                        })()}
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>
            </form>
            </Dialog>
            <Dialog
                header={t('Common.SetMaskTab', { tab: [t('Maintenance.Tab.Tasks'), t('Maintenance.Tab.Checklists'), t('Maintenance.Tab.Technicians')][maskDialogTabIndex] ?? t('Maintenance.Tab.Tasks') })}
                visible={maskVisible}
                style={{ width: '70vw' }}
                onHide={() => setMaskVisible(false)}
            >
        <div className="flex flex-col">
            <p className="text-sm text-gray-600 mb-2">{t('MaintenanceTemplateList.MaskHelp')}</p>
            <div className="flex flex-wrap gap-2 mb-2">
                <button type="button" onClick={maskDialogSelectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.SelectAll')}</button>
                <button type="button" onClick={maskDialogDeselectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.DeselectAllExceptId')}</button>
            </div>
            {getMaskDialogContext().columnsArray.map((item) => {
                if (!item?.field || MAINTENANCE_MASK_DIALOG_SKIP_FIELDS.has(item.field)) return null;
                const ctx = getMaskDialogContext();
                return (
                    <div key={item.field} className="flex flex-row border border-black rounded-md p-2 m-1">
                        <MaintenanceMaskDialogCheckbox field={item.field} inputId={`mcd-mask-${item.field}`} title={item.title} columnsVisible={ctx.columnsVisible} onChange={setMaskField} />
                        <label htmlFor={`mcd-mask-${item.field}`} className={`ml-2 ${item.field === 'id' ? '' : 'cursor-pointer'}`}>{item.title}</label>
                    </div>
                );
            })}
            <button type="button" onClick={saveMaskDialogColumns} className="m-1 px-4 py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-700">{t('Common.SaveUpper')}</button>
        </div>
      </Dialog>
<Dialog header={t('Common.Deactivation')} visible={visibleDeactivate} style={{ width: '40vw' }} onHide={() => setVisibleDeactivate(false)}>
            <form onSubmit={formikDeactivation.handleSubmit}>
              <div className="flex flex-columns justify-between">
                <label>
                  Dátum:
                <input
                    value={formikDeactivation.values.deactivation_date} onChange={formikDeactivation.handleChange}
                    name='deactivation_date'
                    type="date" required
                    className="block w-full px-1 py-1 mr-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                /> 
                </label>
                <button type='submit' className='w-fit ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.VYKONAT')}</button>
              </div>
              </form>
            </Dialog>

            <Dialog
                header={favoriteEditReplaceId != null && favoriteEditReplaceId !== '' ? t('Maintenance.EditServiceTechnician') : t('Maintenance.AddServiceTechnician')}
                visible={visibleFavoritePicker}
                style={{ width: 'min(90vw, 40rem)' }}
                onHide={() => { setVisibleFavoritePicker(false); resetFavoriteWizard(); }}
            >
                <p className="text-sm text-gray-600 mb-3">{t('Ui.R67.Servisneho_technika_tu_len_vyberiete_zo_zoznamu_kontaktov_kt')}</p>
                <div className="space-y-3">
                    <div>
                        <label htmlFor="favorite_wizard_company" className="block text-md font-semibold text-gray-800">{t('Common.ServiceCompany')}</label>
                        <select
                            id="favorite_wizard_company"
                            value={favoriteWizardCompanyId}
                            onChange={(e) => onFavoriteWizardCompanyChange(e.target.value)}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                            <option value="">{t('Ui.R67.Vyber_serv_firmu_2')}</option>
                            {(state.maintenance_companies || []).map((mc) => (
                                <option key={mc.id} value={mc.id}>{mc.name}</option>
                            ))}
                        </select>
                    </div>
                    {favoriteWizardCompanyId !== '' && favoriteWizardCompanyId != null && (
                        <div>
                            <label htmlFor="favorite_wizard_lecturer" className="block text-md font-semibold text-gray-800">Druh technika</label>
                            <select
                                id="favorite_wizard_lecturer"
                                value={favoriteWizardLecturerId === '' ? '' : String(favoriteWizardLecturerId)}
                                onChange={(e) => onFavoriteWizardLecturerChange(e.target.value)}
                                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            >
                                <option value="">{t('Ui.R67.Vyber_druh_technika')}</option>
                                <option value="0">Zamestnanec servisnej firmy</option>
                                <option value="1">{t('Common.InternalEmployee')}</option>
                            </select>
                        </div>
                    )}
                    {(favoriteWizardLecturerId === '0' || favoriteWizardLecturerId === '1') && (
                        <div>
                            <label htmlFor="favorite_wizard_contact" className="block text-md font-semibold text-gray-800">{t('Common.ServiceTechnician')}</label>
                            <select
                                id="favorite_wizard_contact"
                                value={favoriteWizardContactId === '' ? '' : favoriteWizardContactId}
                                onChange={(e) => setFavoriteWizardContactId(e.target.value)}
                                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            >
                                <option value="">{t('Ui.R67.Vyber_servisneho_technika')}</option>
                                {favoriteWizardFilteredContacts.map((c) => {
                                    const row = techniciansTableData.find((t) => String(t.id) === String(c.id));
                                    const label = row
                                        ? (row.employee_id ? (row.employee?.name ?? row.name) : row.name)
                                        : (c.employee_id ? (c.employee?.name ?? c.name) : c.name);
                                    return (
                                        <option key={c.id} value={c.id}>{label || `#${c.id}`}</option>
                                    );
                                })}
                            </select>
                            {favoriteAddDuplicateSelection && (
                                <p className="text-sm text-amber-800 mt-2" role="status">{t('Ui.R67.Tento_servisny_technik_uz_je_pre_tento_stroj_v_zozname_nemoz')}</p>
                            )}
                        </div>
                    )}
                </div>
                <div className="flex justify-end gap-2 mt-6">
                    <button type="button" className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md" onClick={() => { setVisibleFavoritePicker(false); resetFavoriteWizard(); }}>{t('Common.Cancel')}</button>
                    <button
                        type="button"
                        disabled={!canSaveFavoriteDialog}
                        className="px-4 py-2 text-white bg-zinc-900 rounded-md hover:bg-zinc-700 disabled:opacity-25 disabled:cursor-not-allowed"
                        onClick={saveFavoritePicker}
                    >{t('Common.Save')}</button>
                </div>
            </Dialog>
            </div>
            </> 
            );
} 
